<template>
  <div class="pb_content">
    <div class="pb_content_body" style="position: relative; margin: 0">
      <div class="right">
        <div class="stepBg">
          <div v-if="steps == 1" class="first" @click="navSteps(1)">
            <div>
              <img src="../../assets/icon/first.png" alt />
            </div>
            <div>填写基本信息</div>
          </div>
          <div v-else class="firstNo" @click="navSteps(1)">
            <div>
              <img src="../../assets/icon/firstNo.png" alt />
            </div>
            <div>填写基本信息</div>
          </div>
          <div v-show="cidType === 0" class="secondNo">
            <div v-if="steps == 2" class="newSteps second" @click="navSteps(2)">
              <div style="margin: 5px 10px 0 0; width: 2rem">
                <img src="../../assets/icon/second.png" alt />
              </div>
              <div>选择项目框架</div>
            </div>
            <div v-else class="newSteps secondNo" @click="navSteps(2)">
              <div>
                <img src="../../assets/icon/secondNo.png" alt />
              </div>
              <div>选择项目框架</div>
            </div>
          </div>

          <div v-if="steps == 3" class="third" @click="navSteps(3)">
            <div>
              <img src="../../assets/icon/third.png" alt />
            </div>
            <div>上传项目内容</div>
          </div>
          <div v-else class="thirdNo" @click="navSteps(3)">
            <div>
              <img src="../../assets/icon/thirdNo.png" alt />
            </div>
            <div>上传项目内容</div>
          </div>
          <div v-if="steps == 4" class="four">
            <div>
              <img src="../../assets/icon/four.png" alt />
            </div>
            <div>上传完成</div>
          </div>
          <div v-else class="fourNo">
            <div>
              <img src="../../assets/icon/fourNo.png" alt />
            </div>
            <div>上传完成</div>
          </div>
        </div>
        <!-- <div style="display: flex; margin-top: 20px; position: relative"> -->
        <div style="width: 100%; height: 100%; overflow: auto" ref="stepBox">
          <div class="courseTop">
            <div class="stepsNav">
              <h3 class="info_title" v-if="steps == 1">项目内容填写</h3>
              <h3 class="info_title" v-if="steps == 2">请选择项目框架</h3>
              <h3 class="info_title" v-if="steps == 3">项目内容填写</h3>
              <h3 class="info_title" v-if="steps == 4">上传项目</h3>
              <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 15px">
                <el-breadcrumb-item :to="{
                  path:
                    '/course?userid=' +
                    userid +
                    '&oid=' +
                    oid +
                    '&org=' +
                    org,
                }">项目管理</el-breadcrumb-item>
                <el-breadcrumb-item>
                  <span style="color: rgb(15, 126, 255)">添加项目</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div v-if="steps == 1 || steps == 2 || steps == 3" class="stepsWord">
              {{
              steps == 1
              ? "第一步"
              : steps == 2
              ? "第二步"
              : steps == 3
              ? "第三步"
              : ""
              }}
            </div>
          </div>
          <div class="rightBox" v-if="this.steps == 1">
            <div class="whiteBg">
              <div class="right_title">项目基本信息</div>
              <div class="basic_box">
                <div class="big_box">
                  <div class="left_first">
                    <div>
                      <div>
                        <div class="bInfo_title" style="margin-bottom: 15px">
                          <!-- <span style="color: red">*</span>  -->
                          项目名称
                        </div>
                        <div style="display: flex; margin-right: 20px">
                          <img src="../../assets/icon/projectName.png" alt style="margin-right: 8px" />
                          <input type="text" placeholder="请输入项目名称" class="binfo_input" v-model="courseName" />
                        </div>
                      </div>
                      <div class="both">
                        <div class="choose">
                          <div class="all_choose" v-for="(item, index) in CourseType[0]" :key="index">
                            <span>{{ item.name }}</span>
                            <el-checkbox-group v-model="courseTypeId">
                              <el-checkbox v-for="item1 in CourseTypeJson[item.id]" :key="item1.id" :label="item1.id">{{
                              item1.name }}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="whiteBg" style="border-radius: 0">
              <div class="right_first">
                <div class="right_title">上传封面与成员</div>

                <div style="
                    padding: 0 0 50px 20px;
                    display: flex;
                    align-items: baseline;
                    justify-content: flex-start;
                    margin: 0 auto;
                  ">
                  <div>
                    <div class="bInfo_title" style="margin-top: 0 !important">
                      项目封面
                    </div>
                    <div class="uploadFm" @click="choosePicVisible = true" v-if="cover.length == 0">
                      <img src="../../assets/icon/addPoster.png" alt="" />
                    </div>
                    <el-upload :class="{ disUoloadSty: noneBtnImg }" class="upCss" action="#" list-type="picture"
                      v-loading="uploadLoading1" :http-request="beforeUpload1" ref="upload1"
                      :on-preview="handlePictureCardPreview" :on-remove="handle_remove1" :show-file-list="true"
                      :file-list="cover" accept="image/*" :limit="1" :on-exceed="onExceed" v-else>
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <div style="
                      display: flex;
                      flex-flow: row nowrap;
                      flex-direction: row;
                      flex-wrap: wrap;
                      align-items: baseline;
                      margin: 0 30px;
                    ">
                    <!-- <div style="margin: 0 80px">
                      <div class="bInfo_title">
                        选择项目成员
                      </div>
                      <div
                        class="addPeople"
                        @click="addPP"
                        v-if="this.checkboxList.length == 0"
                      >添加成员</div>
                      <div class="addPeople" @click="addPP" v-else>已添加，点击查看</div>
                    </div>-->
                    <div style="margin: 0 30px 0 0">
                      <div class="bInfo_title">添加权限</div>
                      <div class="addPeople" @click="dialogVisibleClass = true">
                        添加权限
                      </div>
                    </div>
                    <div style="flex: 0.5 1 0%; margin: 0" v-if="courseUserid != '' ? courseUserid == userid : true">
                      <div class="bInfo_title">协同编辑</div>
                      <div class="addPeople" @click="dialogVisibleMember = true" style="background: #6b92c9">
                        添加协同成员
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="whiteBg" style="border-radius: 0; margin-top: 15px">
              <div class="right_title">项目简要描述</div>
              <div style="width: 95%; margin: 15px auto">
                <div style="width: 55%">
                  <textarea rows="8" class="binfo_input" cols v-model="courseText"></textarea>
                </div>
              </div>
              <!-- <div style="width: 95%; margin: 15px auto">
                <el-switch
                  v-model="isTeacherSee"
                  active-text="允许给其他老师查看"
                  style="padding-bottom: 30px"
                ></el-switch>
              </div>-->
              <div style="width: 95%; margin: 15px auto">
                <el-switch v-model="isTeacherSee" active-text="是否公开此项目" style="padding-bottom: 30px"></el-switch>
              </div>
            </div>
            <div class="whiteBg" style="border-radius: 0; margin-top: 15px; padding-bottom: 20px">
              <div class="right_title">目标管理</div>
              <div style="margin: 15px auto; padding: 0 0 0 20px">
                <div style="
                    width: 100%%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-content: center;
                    align-items: center;
                    justify-content: space-between;
                  ">
                  <div style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: flex-start;
                      width: 100%;
                      flex-direction: column;
                      flex-wrap: nowrap;
                      position: relative;
                    ">
                    <!-- <div style="margin-right: 15px; min-width: 120px">
                      请选择评价指标
                    </div>
                    <div>
                      <el-select
                        v-model="evalua"
                        placeholder="请选择体系"
                        @change="checkEva"
                      >
                        <el-option
                          v-for="(e, eIndex) in evaJuri"
                          :key="eIndex"
                          :label="e.title"
                          :value="e.id"
                        ></el-option>
                      </el-select>
                    </div> -->
                    <!-- <div
                      @click="openT"
                      class="addPeople"
                      style="
                        background: #6b92c9;
                        margin: 0 0 0 15px;
                        position: absolute;
                        right: 23%;
                      "
                    >
                      前往设置目标管理
                    </div> -->
                    <div class="e_box">
                      <div class="e_card" v-for="(item, index) in evaJuri" :key="index">
                        <div class="e_card_picture">
                          <img src="../../assets/e_picture.png" />
                        </div>
                        <div class="e_card_name">
                          <span>{{ item.title }}</span>
                        </div>
                        <!-- <div class="e_card_time">
                          <span>{{ item.time }}</span>
                        </div> -->
                        <div class="e_card_btn">
                          <span @click="checkEva(item.id)">导入</span>
                          <!-- <span @click="openT">前往设置</span> -->
                        </div>
                      </div>
                      <div class="addEva" @click="openT">
                        <img src="../../assets/icon/addEva.png" alt="" />
                      </div>
                      <div v-if="evaJuri.length === 0" style="margin: 0 auto; color: #6e6e6e">
                        暂无数据
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="evalua" style="
                    border: 1px solid #e5e5e5;
                    width: 95%;
                    margin-top: 30px;
                    box-shadow: 3px 1px 15px 3px #e0e0e0;
                  ">
                  <div class="e_add_top">
                    <div class="e_add_title">
                      <span>当前使用目标管理</span>
                      <span>{{ eTitle }}</span>
                      <img src="../../assets/line.png" class="cru_line" style="
                          width: 125px;
                          height: 20px;
                          bottom: -10px;
                          left: 155px;
                        " />
                      <!-- <el-input
                        v-model="eTitle"
                        placeholder="请输入名称"
                        @change="setMindData"
                      ></el-input>-->
                    </div>
                  </div>
                  <div class="e_add_content">
                    <div class="e_add_list_pbox">
                      <div class="e_add_list_pbox_title">
                        <span class="type_title">切换模式</span>
                        <div class="type_content">
                          <span :class="{ active: typeMode == 1 }" @click="OtherMb(1)">目标树</span>
                          <span :class="{ active: typeMode == 2 }" @click="OtherMb(2)">目标罗盘</span>
                          <span :class="{ active: typeMode == 3 }" @click="OtherMb(3)">目标看板</span>
                        </div>
                      </div>
                      <div class="e_add_list_pbox_content">
                        <Mind :showBar="false" :mindData="data" v-show="typeMode == 1"></Mind>
                        <Sunburst :Josn="eJson" :num="eJSONNum" style="width: 100%" v-if="typeMode == 2"></Sunburst>
                        <SeeBoard :Josn="eJson" :num="eJSONNum" :ename="eTitle" style="width: 100%"
                          v-if="typeMode == 3"></SeeBoard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightBox" v-if="this.steps == 2">
            <div class="basic_box" style="padding: 20px 30px 0px !important; box-sizing: border-box">
              <!-- <div
                style="
                  color: #b8b8b8;
                  background: #fff;
                  width: 26%;
                  height: 40px;
                  border-radius: 15px;
                  padding-left: 20px;
                  line-height: 40px;
                  font-size: 17px;
                  box-shadow: 0px 1px 2px 2px #e0e0e0;
                "
              >-->
              <div class="right_title" style="border: none; margin: 0; padding: 0">
                请选择合适的项目模板
              </div>
              <div class="wordbox">
                <div class="wordTeacher" v-for="(aa, indexF) in templateArray" :key="indexF" @click="checkTemplate(aa)">
                  <div class="wordPic">
                    <img src="../../assets/icon/wordMub.png" alt />
                  </div>

                  <div style="
                      margin-top: 10px;
                      line-height: 19px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      padding: 0 20px;
                    ">
                    {{ aa.title }}
                  </div>
                </div>
                <div class="wordTeacher" @click="checkTemplate2()">
                  <div class="wordPic">
                    <img src="../../assets/icon/wordMub.png" alt />
                  </div>

                  <div style="
                      margin-top: 10px;
                      line-height: 19px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      padding: 0 20px;
                    ">
                    新建项目
                  </div>
                </div>
                <div class="wordTeacher" @click="checkTemplate1()">
                  <div class="wordPic">
                    <img src="../../assets/icon/wordMub.png" alt />
                  </div>

                  <div style="
                      margin-top: 10px;
                      line-height: 19px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      padding: 0 20px;
                    ">
                    我的项目
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightBox" v-if="this.steps == 3" ref="rightboxR">
            <div class="basic_box">
              <div style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  position: sticky;
                  top: 0;
                  background: #fff;
                  z-index: 99;
                  width: 100%;
                  padding: 0 20px 0 20px;
                  box-sizing: border-box;
                ">
                <div class="cru_selectBox">
                  <div v-for="(item, index) in unitJson" :key="index" class="cru_select"
                    :class="unitIndex == index ? 'cru_selected' : ''" @click="unitSet(index)">
                    第{{ index + 1 }}阶段
                  </div>
                  <img src="../../assets/line.png" class="cru_line" :style="{
                    left: offsetLetfPx + 'px',
                  }" />
                </div>
                <div class="addStageImg" @click="addunit()">
                  <img src="../../assets/icon/add.png" alt />
                </div>
              </div>

              <div style="margin: 0 0 40px 0; padding: 0 20px 0 20px"
                v-for="(item, index) in unitJson[unitIndex].chapterInfo" :key="index">
                <div>
                  <div class="chapter_contentbox">
                    <div>第{{ unitIndex + 1 }}阶段</div>
                    <div>
                      <input type="text" placeholder="阶段标题" class="binfo_input" v-model="unitJson[unitIndex].dyName" />
                    </div>
                    <div v-if="unitJson.length > 1" @click="deleteUnit(unitIndex)"></div>
                  </div>
                </div>
                <div style="
                    margin: 50px 0px 10px;
                    font-size: 1.5em;
                    font-weight: 700;
                    color: #0f7eff;
                  ">
                  添加任务
                </div>
                <div class="taskBorder" v-for="(itemTask, itemTaskIndex) in item.taskJson" :key="itemTaskIndex">
                  <div>
                    <div>
                      <div style="font-size: 22px; color: #8e8e8e">
                        任务{{ itemTaskIndex + 1 }}
                      </div>
                      <div class="chapter_contentbox" style="
                          flex-direction: row;
                          justify-content: flex-start;
                          align-items: center;
                        ">
                        <div style="
                            border-left: 6px solid #5699e8;
                            height: 20px;
                            padding-left: 10px;
                            line-height: 22px;
                          ">
                          任务名称
                        </div>
                        <div>
                          <input type="text" placeholder="输入任务名称" class="binfo_input" style="border-radius: 4px"
                            v-model="
                              unitJson[unitIndex].chapterInfo[0].taskJson[
                                itemTaskIndex
                              ].task
                            " />
                        </div>
                        <div class="remove" v-if="item.taskJson.length > 1" @click="deleteTask(itemTaskIndex)"
                          style="position: absolute; right: 55px"></div>
                      </div>
                      <div style="
                          display: flex;
                          margin: 0 0 20px 0;
                          flex-direction: row;
                          justify-content: flex-start;
                          align-items: center;
                          width: 70.5% !important;
                          padding-top: 30px;
                        ">
                        <div class="lineTitle">任务描述</div>
                        <div class="line"></div>
                      </div>
                      <div>
                        <editor-bar style="width: 90% !important; margin: 0" placeholder="请输入任务描述" v-model="
                          unitJson[unitIndex].chapterInfo[0].taskJson[
                            itemTaskIndex
                          ].taskDetail
                        " @change="change"></editor-bar>
                        <!-- <textarea
                          rows="6"
                          class="binfo_input"
                          placeholder="请输入任务描述"
                          cols
                          style="width: 70.5% !important; height: 120px"
                          v-model="
                            unitJson[unitIndex].chapterInfo[0].taskJson[
                              itemTaskIndex
                            ].taskDetail
                          "
                        ></textarea>-->
                      </div>
                    </div>
                  </div>
                  <div class="basic_box" style="
                      margin: 0;
                      min-height: 0;
                      width: 90% !important;
                      paddint-top: 10px !important;
                    ">
                    <div style="
                        display: flex;
                        margin: 0 0 20px 0;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                      ">
                      <div class="lineTitle">学习内容</div>
                      <div class="line"></div>
                    </div>
                    <div>
                      <div class="add_chapters_box" v-if="
                        itemTask.chapterData &&
                        itemTask.chapterData.length == 0
                      " style="height: 185px"></div>
                      <div v-else class="add_chapters_box" style="display: flex; flex-direction: column">
                        <div class="chapter_upload" v-for="(item1, index1) in itemTask.chapterData" :key="item1.id"
                          @click="
                            getChapterData(
                              $event,
                              unitIndex,
                              index,
                              index1,
                              item1.type
                            )
                          ">
                          <div class="chapter_upload_t" style="width: 100%"></div>
                          <div class="chapter_upload_o" style="
                              position: relative;
                              display: flex;
                              align-items: center;
                            ">
                            <div class="chapter_upload_l" style="padding: 1px 0 0 10px">
                              <div v-if="item1.type == 2" class="chapter_upload_l_i1"></div>
                              <div v-if="
                                item1.type == 3 ||
                                item1.type == 6 ||
                                item1.type == 7
                              " class="chapter_upload_l_i5" style="margin-left: 1px"></div>
                              <div v-if="item1.type == 8" class="chapter_upload_l_i8" style="margin-left: 1px"></div>
                            </div>
                            <div class="chapter_upload_ic" style="
                                cursor: pointer;
                                position: absolute;
                                width: 45px;
                                right: 0;
                                top: 0;
                              ">
                              <div class="chapter_upload_ic_l"></div>
                              <div class="chapter_upload_ic_r" style="position: absolute" @click.stop="
                                deleteChapterData(
                                  $event,
                                  unitIndex,
                                  index,
                                  index1,
                                  itemTaskIndex
                                )
                              ">
                                <div></div>
                              </div>
                            </div>
                            <div class="chapter_upload_n">
                              <input v-if="
                                item1.type == 2 ||
                                item1.type == 3 ||
                                item1.type == 7
                              " :placeholder="item1.name" @change="
                                  updataVideoT(
                                    $event,
                                    unitIndex,
                                    chapterIndex,
                                    index1
                                  )
                                " style="
                                  border: none;
                                  outline: none;
                                  width: 80%;
                                  minwidth: 215px;
                                  z-index: 99;
                                  font-size: 14px;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                " />
                              <input :placeholder="item1.name" v-if="item1.type == 6" style="
                                  border: none;
                                  outline: none;
                                  width: 80%;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                " readonly="true" @click="selectAttText(itemTaskIndex, index1)" />
                              <input :placeholder="item1.name" v-if="item1.type == 8" style="
                                  border: none;
                                  outline: none;
                                  width: 80%;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                " readonly="true" @click="selectLine(itemTaskIndex, index1)" />
                              <div class="chapter_upload_ud" style="z-index: 99">
                                <div class="chapter_upload_up" @click="
                                  upCd($event, unitIndex, index, index1)
                                "></div>
                                <div class="chapter_upload_down" @click="
                                  downCd($event, unitIndex, index, index1)
                                "></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="add_info_box">
                      <button class="info_btn" @click="addImg($event)">
                        添加教学视频
                        <input type="file" accept="video/mp4, video/quicktime, video/x-msvideo" style="display: none"
                          capture="camera" v-if="inputShow" @change="
                            beforeUpload2($event, unitIndex, 2, itemTaskIndex)
                          " />
                      </button>
                      <button class="info_btn" @click="addImg($event)">
                        添加教学附件
                        <input type="file"
                          accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style="display: none" v-if="inputShow" @change="
                            beforeUpload2($event, unitIndex, 3, itemTaskIndex)
                          " />
                      </button>
                      <button class="info_btn" @click="addAttText(itemTaskIndex)">
                        添加图文
                      </button>
                      <button class="info_btn" @click="openLine(itemTaskIndex)">
                        添加链接
                      </button>
                    </div>
                  </div>
                  <div style="
                      flex-direction: row;
                      justify-content: flex-start;
                      align-items: center;
                      padding: 0 0 0 30px;
                      paddint-top: 10px !important;
                    ">
                    <div style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 20px;
                      ">
                      <div class="lineTitle">练习内容</div>
                      <div class="line" style="width: 90%"></div>
                    </div>
                  </div>
                  <div class="toolChoose" style="padding: 0 0 0 30px">
                    <div class="tools">
                      <div class="leftTools" style="
                          width: 95%;
                          padding: 0 0 15px 0;
                          border-bottom: 1px solid #efefef;
                          margin-bottom: 15px;
                        " v-for="(itemTool, toolIndex) in itemTask.toolChoose" :key="toolIndex">
                        <div>
                          <textarea rows="3" type="text" placeholder="添加工具描述" class="binfo_input"
                            style="margin: 0 0 20px 0; width: 71.5% !important"
                            v-model="itemTool.toolDetail"></textarea>
                        </div>
                        <div style="
                            display: flex;
                            flex-direction: row;
                            align-items: baseline;
                            flex-wrap: nowrap;
                            justify-content: flex-start;
                            position: relative;
                          ">
                          <div style="margin-right: 20px; font-weight: bold">
                            工具 {{ toolIndex + 1 }} ：
                          </div>
                          <div class="chooseWho">
                            <div :class="
                              itemTool.toolType == 0 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 0), $forceUpdate()">
                              互动类
                            </div>
                            <div :class="
                              itemTool.toolType == 1 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 1), $forceUpdate()">
                              思维类
                            </div>
                            <div :class="
                              itemTool.toolType == 2 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 2), $forceUpdate()">
                              评价类
                            </div>
                            <div :class="
                              itemTool.toolType == 3 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 3), $forceUpdate()">
                              编程类
                            </div>
                            <div :class="
                              itemTool.toolType == 5 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 5), $forceUpdate()">
                              学科类
                            </div>
                            <div :class="
                              itemTool.toolType == 4 ? 'isChooseActive' : ''
                            " @click="(itemTool.toolType = 4), $forceUpdate()">
                              其他
                            </div>
                          </div>
                          <div class="remove" @click="deleteTool(itemTaskIndex, toolIndex)"
                            v-if="itemTask.toolChoose.length > 1" style="position: absolute; right: 55px"></div>
                        </div>

                        <div style="min-height: 163px">
                          <div class="toolSort" v-if="itemTool.toolType == 0">
                            <!-- <div class="tool">
                              <div
                                class="whiteBIcon"
                                @click="addTools(8, itemTaskIndex, toolIndex)"
                              >
                                <img src="../../assets/icon/secondToolList/library.png" alt />
                                <div style="margin: 5px 0">素材库</div>
                              </div>
                              <div class="check" @click="addTools(8, itemTaskIndex, toolIndex)">
                                <img
                                  src="../../assets/icon/checkNo.png"
                                  alt
                                  v-if="itemTool.tool.indexOf(8) == -1"
                                />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>-->
                            <!-- <div class="tool">
                              <div
                                class="whiteBIcon"
                                @click="addTools(17, itemTaskIndex, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/secondToolList/library.png"
                                  alt
                               />
                                <div style="margin: 5px 0">学习资料</div>
                              </div>
                              <div
                                class="check"
                                @click="addTools(17, itemTaskIndex, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/checkNo.png"
                                  alt
                                  v-if="itemTool.tool.indexOf(17) == -1"
                                />
                                <img
                                  src="../../assets/icon/checkedIs.png"
                                  alt
                                  v-else
                                />
                              </div>
                            </div> -->
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(10, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/time.png" alt />
                                <div style="margin: 5px 0">倒计时</div>
                              </div>
                              <div class="check" @click="addTools(10, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(10) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                          </div>
                          <div class="toolSort" v-if="itemTool.toolType == 1">
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(7, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/mindNetwork.png" alt />
                                <div style="margin: 5px 0">思维网格</div>
                              </div>
                              <div class="check" @click="addTools(7, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(7) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(1, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/whiteBoard.png" alt />
                                <div style="margin: 5px 0">电子白板</div>
                              </div>
                              <div class="check" @click="addTools(1, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(1) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(2, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/note.png" alt />
                                <div style="margin: 5px 0">便签</div>
                              </div>
                              <div class="check" @click="addTools(2, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(2) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(6, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/doc.png" alt />
                                <div style="margin: 5px 0">协同文档</div>
                              </div>
                              <div class="check" @click="addTools(6, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(6) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(3, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/mindMapping.png" alt />
                                <div style="margin: 5px 0">思维导图</div>
                              </div>
                              <div class="check" @click="addTools(3, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(3) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                          </div>
                          <div class="toolSort" v-if="itemTool.toolType == 2">
                            <!-- <div class="tool">
                              <div
                                class="whiteBIcon"
                                @click="addTools(5, itemTaskIndex, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/thirdToolList/score.png"
                                  alt
                                />
                                <div style="margin: 5px 0">量规评分</div>
                              </div>
                              <div
                                class="check"
                                @click="addTools(5, itemTaskIndex, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/checkNo.png"
                                  alt
                                  v-if="itemTool.tool.indexOf(5) == -1"
                                />
                                <img
                                  src="../../assets/icon/checkedIs.png"
                                  alt
                                  v-else
                                />
                              </div>
                            </div>-->
                            <div class="tool">
                              <div class="whiteBIcon" @click="openTools(itemTaskIndex, 4, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/ask.png" alt />
                                <div style="margin: 5px 0">选择题</div>
                              </div>
                              <div class="check" @click="addTools(4, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(4) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="openTools(itemTaskIndex, 15, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/answer.png" alt />
                                <div style="margin: 5px 0">问答工具</div>
                              </div>
                              <div class="check" @click="addTools(15, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(15) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(16, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/work.png" alt />
                                <div style="margin: 5px 0">作业提交</div>
                              </div>
                              <div class="check" @click="addTools(16, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(16) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="openTools(itemTaskIndex, 40, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/eval.png" alt />
                                <div style="margin: 5px 0">学生互评</div>
                              </div>
                              <div class="check" @click="addTools(40, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(40) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="openTools(itemTaskIndex, 41, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/select.png" alt />
                                <div style="margin: 5px 0">选择填空</div>
                              </div>
                              <div class="check" @click="addTools(41, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(41) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <!-- <div class="tool">
                              <div
                                class="whiteBIcon"
                                @click="openTools(itemTaskIndex, 42, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/thirdToolList/mp3.png"
                                  alt
                                />
                                <div style="margin: 5px 0">上传音频</div>
                              </div>
                              <div
                                class="check"
                                @click="addTools(42, itemTaskIndex, toolIndex)"
                              >
                                <img
                                  src="../../assets/icon/checkNo.png"
                                  alt
                                  v-if="itemTool.tool.indexOf(42) == -1"
                                />
                                <img
                                  src="../../assets/icon/checkedIs.png"
                                  alt
                                  v-else
                                />
                              </div>
                            </div> -->
                          </div>
                          <div class="toolSort" v-if="itemTool.toolType == 3">
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(18, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/trainPlatform.png" alt />
                                <div style="margin: 5px 0">训练平台</div>
                              </div>
                              <div class="check" @click="addTools(18, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(18) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(21, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/fourthToolList/program.png" alt />
                                <div style="margin: 5px 0">编程平台</div>
                              </div>
                              <div class="check" @click="addTools(21, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(21) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(22, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/fourthToolList/AIprogram2.png" alt />
                                <div style="margin: 5px 0">AI体验</div>
                              </div>
                              <div class="check" @click="addTools(22, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(22) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(23, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/fourthToolList/Pythonprogram.png" alt />
                                <div style="margin: 5px 0">Python</div>
                              </div>
                              <div class="check" @click="addTools(23, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(23) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(24, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/fourthToolList/program.png" alt />
                                <div style="margin: 5px 0">AI平台</div>
                              </div>
                              <div class="check" @click="addTools(24, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(24) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(32, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/code.png" alt />
                                <div style="margin: 5px 0">源码编辑</div>
                              </div>
                              <div class="check" @click="addTools(32, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(32) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                          </div>
                          <div class="toolSort" v-if="itemTool.toolType == 5">
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(28, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/translation.png" alt />
                                <div style="margin: 5px 0">翻译</div>
                              </div>
                              <div class="check" @click="addTools(28, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(28) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(37, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/mohe.png" alt />
                                <div style="margin: 5px 0">魔盒识字</div>
                              </div>
                              <div class="check" @click="addTools(37, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(37) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(38, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/24game.png" alt />
                                <div style="margin: 5px 0">24点</div>
                              </div>
                              <div class="check" @click="addTools(38, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(38) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(31, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/networkPanel.png" alt />
                                <div style="margin: 5px 0">数学画板</div>
                              </div>
                              <div class="check" @click="addTools(31, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(31) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(39, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/secondToolList/GeoGebra.png" alt />
                                <div style="margin: 5px 0">GeoGebra</div>
                              </div>
                              <div class="check" @click="addTools(39, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(39) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                          </div>
                          <div class="toolSort" v-if="itemTool.toolType == 4">
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(26, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/courseDesign.png" alt />
                                <div style="margin: 5px 0">项目设计</div>
                              </div>
                              <div class="check" @click="addTools(26, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(26) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                            <div class="tool">
                              <div class="whiteBIcon" @click="addTools(25, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/thirdToolList/evalua.png" alt />
                                <div style="margin: 5px 0">目标管理</div>
                              </div>
                              <div class="check" @click="addTools(25, itemTaskIndex, toolIndex)">
                                <img src="../../assets/icon/checkNo.png" alt v-if="itemTool.tool.indexOf(25) == -1" />
                                <img src="../../assets/icon/checkedIs.png" alt v-else />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="addToolFun" @click="addToolFun(itemTaskIndex)">
                        <div class="addToolImg">
                          <img src="../../assets/icon/add.png" alt />
                        </div>
                        <div>添加工具</div>
                      </div>
                    </div>
                  </div>
                  <div class="elist_css">
                    <div class="elist_title">
                      <div style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                          margin-bottom: 20px;
                        ">
                        <div class="lineTitle">评价设置</div>
                        <div class="line" style="width: 90%"></div>
                      </div>
                    </div>
                    <div class="mbCss">
                      <div class="pjCss">
                        <div v-if="itemTask.eList && itemTask.eList.length" class="elist_input">
                          <div v-for="(eItem, eIndex) in itemTask.eList" :key="eIndex" class="elist_input_box">
                            <span>评价名称：</span>
                            <input type="input" v-model="itemTask.eList[eIndex].value" placeholder="填写评价名称" />
                            <span>评星等级：</span>
                            <el-rate v-model="itemTask.eList[eIndex].score" @change="setEListStar()" disabled></el-rate>
                            <div class="remove" @click="
                              deletEList(unitIndex, itemTaskIndex, eIndex)
                            "></div>
                            <div class="elist_inptu_text">
                              <span>评价描述：</span>
                              <input type="input" v-model="itemTask.eList[eIndex].detail" placeholder="填写评价描述" />
                            </div>
                          </div>
                        </div>
                        <div class="addToolFun" @click="addEList(unitIndex, itemTaskIndex)"
                          style="margin: 35px 35px 0 0">
                          <div class="addToolImg">
                            <img src="../../assets/icon/add.png" alt />
                          </div>
                          <div>添加</div>
                        </div>
                      </div>
                      <div v-if="evalua" style="
                          border: 1px solid #e5e5e5;
                          width: 55%;
                          margin-top: 20px;
                          box-shadow: 3px 1px 15px 3px #e0e0e0;
                        " class="evaCss">
                        <div class="e_add_top">
                          <div class="e_add_title">
                            <span>当前使用目标管理</span>
                            <span>{{ eTitle }}</span>
                            <img src="../../assets/line.png" class="cru_line" style="
                                width: 125px;
                                height: 20px;
                                bottom: -10px;
                                left: 155px;
                              " />
                            <!-- <el-input
                        v-model="eTitle"
                        placeholder="请输入名称"
                        @change="setMindData"
                            ></el-input>-->
                          </div>
                        </div>
                        <div class="e_add_content" style="width: 100%">
                          <div class="e_add_list_pbox" style="width: 100%">
                            <div class="e_add_list_pbox_title">
                              <span class="type_title">切换模式</span>
                              <div class="type_content">
                                <span :class="{ active: typeMode == 1 }" @click="OtherMb(1)">目标树</span>
                                <span :class="{ active: typeMode == 2 }" @click="OtherMb(2)">目标罗盘</span>
                                <span :class="{ active: typeMode == 3 }" @click="OtherMb(3)">目标看板</span>
                              </div>
                            </div>
                            <div class="e_add_list_pbox_content">
                              <Mind :showBar="false" :mindData="data" style="width: 100%" :jsmindId="
                                unitIndex + '-' + itemTaskIndex + 'mind'
                              " v-if="typeMode == 1"></Mind>
                              <Sunburst :Josn="eJson" :num="eJSONNum" style="width: 100%" v-if="typeMode == 2">
                              </Sunburst>
                              <SeeBoard :Josn="eJson" :num="eJSONNum" :ename="eTitle" style="width: 100%"
                                v-if="typeMode == 3"></SeeBoard>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="funBlock" style="padding: 0">
                    <div class="fold">
                      <div @click="fold(itemTaskIndex, $event, 1)">折叠</div>
                      <div class="arrow">
                        <img src="../../assets/icon/fold.png" alt />
                      </div>
                    </div>
                    <div class="fold">
                      <div @click="fold(itemTaskIndex, $event, 0)">展开</div>
                      <div class="arrow">
                        <img src="../../assets/icon/expand.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="addTaskBorder" @click="addTaskBorder">
                  <div>
                    <img src="../../assets/icon/addHw.png" alt />
                    <span>添加任务</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="
              width: calc(100% - 20px);
              background: rgb(255, 255, 255);
              border-radius: 10px;
            " v-if="this.steps == 4">
            <div class="basic_box_success">
              <div class="right_img">
                <img src="../../assets/icon/right.png" alt />
              </div>
              <div style="font-weight: bold">成功</div>
              <!-- <div>您的项目编号</div>
              <div class="number">{{ number }}</div>-->
              <!-- <div class="success_button">
                <div class="look_course" @click="isNoFinsh">
                  邀请老师协同编辑
                </div>
                <div class="attend_others" @click="goCourse">预览项目</div>
              </div> -->
            </div>
          </div>
          <div class="info_btnBox">
            <button class="info_btn" v-if="steps == 1" @click="
              goTo('/course?userid=' + userid + '&oid=' + oid + '&org=' + org)
            ">
              返回项目
            </button>
            <button class="info_btn" v-if="steps > 1 && steps != 5" @click="lastSteps">
              {{ steps == 4 ? "返回首页" : "上一步" }}
            </button>
            <button class="info_btn" v-if="steps < 5" @click="nextSteps">
              {{ steps == 3 ? "确认上传" : "下一步" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" :append-to-body="true" width="25%" :before-close="handleClose"
      class="dialog_diy2 customWidth">
      <div>请复制该链接邀请协同编辑</div>
      <div>http://www.boomyon.com/index-zhang.com</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">复制链接分享</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="updateBoolean2 ? '查看文档' : '添加文档'" :visible.sync="dialogVisible1" :append-to-body="true"
      width="25%" :before-close="handleClose" class="dialog_diy2 customWidth">
      <el-form>
        <el-form-item label="文档标题">
          <el-input v-model="tTitle" auto-complete="off" placeholder="请输入文档标题名..."></el-input>
        </el-form-item>
        <div>文档简介</div>
        <editor-bar v-model="tdetail" @change="change"></editor-bar>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addWord" v-if="!updateBoolean2">添加</el-button>
        <el-button type="primary" @click="upWord" v-else>修 改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加文档" :visible.sync="dialogVisible2" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy">
      <el-form>
        <el-form-item label="文档标题">
          <el-input v-model="templateC.title" auto-complete="off" placeholder="请输入文档标题名..."></el-input>
        </el-form-item>
        <div>文档内容</div>
        <editor-bar v-model="cTemplate" @change="change"></editor-bar>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearChoose">取 消</el-button>
        <el-button type="primary" @click="wordNext()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加富文本" :visible.sync="dialogVisible6" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy">
      <el-form>
        <el-form-item label="文本标题">
          <el-input v-model="AttText.title" auto-complete="off" @input="change2" placeholder="请输入文本标题..."></el-input>
        </el-form-item>
        <div>富文本内容</div>
        <editor-bar v-model="AttText.text" @change="change"></editor-bar>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearAttText">取 消</el-button>
        <el-button type="primary" @click="isAddOrUpdateAttText">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加链接" :visible.sync="dialogVisible7" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy lineCss">
      <el-form>
        <el-form-item label="链接" :label-width="formLabelWidth">
          <span>
            <el-input placeholder="请输入链接" clearable v-model="line" class="add_input"></el-input>
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearLine">取 消</el-button>
        <el-button type="primary" @click="isAddOrUpdateLine">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加项目成员" :visible.sync="dialogVisible3" :append-to-body="true" width="25%" height="80%"
      :before-close="handleClose" class="addNewPP customWidth">
      <div class="people">
        <div class="people_top">
          <div class="people_nav">选择成员</div>
          <div class="people_top_right">
            <div class="people_search">
              <el-input placeholder="搜索成员" v-model="searchPeople"></el-input>
              <div class="search_img" @click="searchStudent">
                <img src="../../assets/icon/search.png" alt />
              </div>
            </div>
          </div>
        </div>
        <el-checkbox-group v-model="checkboxList" class="people_name">
          <el-checkbox v-for="item in studentJuri" :key="item.userid" :label="item.userid">{{ item.name ? item.name :
          "暂无学生可选" }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="isAddPP">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加权限" :visible.sync="dialogVisibleClass" :append-to-body="true" width="400px" height="80%"
      :before-close="handleClose" class="addNewPP">
      <div class="people" style="height: 300px">
        <div class="people_top">
          <div class="people_nav">选择班级</div>
        </div>
        <el-checkbox-group v-model="checkboxList2" class="people_name">
          <div v-for="(item, index) in grade" :key="item.id">
            <el-checkbox :label="item.id">
              {{ item.name ? item.name : "暂无班级可选" }}
            </el-checkbox>
            <div>
              <span>{{ index }}</span>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleClass = false">取 消</el-button>
        <el-button type="primary" @click="isAddClass">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加协同成员" :visible.sync="dialogVisibleMember" :append-to-body="true" width="25%" height="80%"
      :before-close="handleClose" class="addNewPP customWidth">
      <div class="people">
        <div class="people_top">
          <div class="people_nav">选择成员</div>
          <div class="people_top_right">
            <div class="people_search">
              <el-input placeholder="搜索成员" v-model="searchTN" @keyup.enter.native="getTeacher"></el-input>
              <div class="search_img" @click="getTeacher">
                <img src="../../assets/icon/search.png" alt />
              </div>
            </div>
          </div>
        </div>
        <el-checkbox-group v-model="checkboxList3" class="people_name" v-if="teacherJuri.length">
          <el-checkbox v-for="item in teacherJuri" :key="item.userid" :label="item.userid">
            {{ (item.name ? item.name : "暂无姓名") + " " + item.username }}
          </el-checkbox>
        </el-checkbox-group>
        <div style="text-align: center; margin-top: 10px" v-else>暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMember = false">取 消</el-button>
        <el-button type="primary" @click="isAddPPTeacher">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="创建选择题" :visible.sync="dialogVisible5" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div class="a_add_title" style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          ">
          <div style="margin-right: 20px; font-size: 20px">标题:</div>
          <el-input v-model="askJson.askTitle" placeholder="请输入标题" style="width: 400px"></el-input>
        </div>
        <div class="a_addBox">
          <div style="font-size: 16px; color: #c7c7c7">请输入题目内容</div>
          <div class="a_add_box" v-for="(item1, index1) in askJson.askCount" :key="index1">
            <div class="a_add_head">
              <div>
                {{ index1 + 1 + "、" }}
                <el-input class="a_add_head_input" v-model="askJson.askJson[index1].askstitle" placeholder="请输入题目...">
                </el-input>
              </div>
              <div class="a_add_head_div">
                <el-button type="primary" size="small" @click="addAskList()">添加</el-button>
                <el-button type="primary" size="small" @click="deleteAskList()" v-if="index1 != 0">删除</el-button>
              </div>
            </div>
            <div class="a_add_body">
              <div class="a_add_input">
                <el-input v-for="(item2, checkIndex) in askJson.askJson[index1].askItem" :key="checkIndex"
                  v-model="askJson.askJson[index1].checkList[checkIndex]" placeholder="请输入选项..."
                  style="width: 150px; margin: 10px 10px 0 0"></el-input>
              </div>
              <div class="a_add_body_div">
                <el-button style="margin: 10px 0px 0 0" type="primary" size="small"
                  @click="addcheckList(askJson.askJson[index1])">添加</el-button>
                <el-button type="primary" size="small" style="margin: 10px 0 0 0"
                  @click="deletecheckList(askJson.askJson[index1])" v-if="askJson.askJson[index1].askItem != 1">删除
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="addAsk">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加工具" :visible.sync="dialogVisible4" :append-to-body="true" width="600px"
      :before-close="handleClose" class="dialog_diy addToolsDia">
      <div class="toolChoose" style="padding: 0 0 0 30px">
        <div class="tools">
          <div class="leftTools" style="
              width: 95%;
              padding: 0 0 15px 0;
              border-bottom: 1px solid #efefef;
              margin-bottom: 15px;
            " v-for="(itemTools, itemToolsIndex) in chapTools" :key="itemToolsIndex">
            <div style="
                display: flex;
                flex-direction: row;
                align-items: baseline;
                flex-wrap: nowrap;
                justify-content: flex-start;
                position: relative;
              ">
              <div class="chooseWho">
                <div :class="chapToolsType == 0 ? 'isChooseActive' : ''" @click="chapToolsType = 0">
                  互动类
                </div>
                <div :class="chapToolsType == 1 ? 'isChooseActive' : ''" @click="chapToolsType = 1">
                  思维类
                </div>
                <div :class="chapToolsType == 2 ? 'isChooseActive' : ''" @click="chapToolsType = 2">
                  评价类
                </div>
                <div :class="chapToolsType == 2 ? 'isChooseActive' : ''" @click="chapToolsType = 2">
                  其他
                </div>
              </div>
            </div>

            <div style="min-height: 163px">
              <div class="toolSort" v-if="chapToolsType == 0">
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(8)">
                    <img src="../../assets/icon/secondToolList/library.png" alt />
                    <div style="margin: 5px 0">素材库</div>
                  </div>
                  <div class="check" @click="chapAddTools(8)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(8) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
              </div>
              <div class="toolSort" v-if="chapToolsType == 1">
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(7)">
                    <img src="../../assets/icon/secondToolList/mindNetwork.png" alt />
                    <div style="margin: 5px 0">思维网格</div>
                  </div>
                  <div class="check" @click="chapAddTools(7)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(7) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(1)">
                    <img src="../../assets/icon/secondToolList/whiteBoard.png" alt />
                    <div style="margin: 5px 0">电子白板</div>
                  </div>
                  <div class="check" @click="chapAddTools(1)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(1) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(2)">
                    <img src="../../assets/icon/secondToolList/note.png" alt />
                    <div style="margin: 5px 0">便签</div>
                  </div>
                  <div class="check" @click="chapAddTools(2)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(2) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(6)">
                    <img src="../../assets/icon/secondToolList/doc.png" alt />
                    <div style="margin: 5px 0">协同文档</div>
                  </div>
                  <div class="check" @click="chapAddTools(6)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(6) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(3)">
                    <img src="../../assets/icon/secondToolList/mindMapping.png" alt />
                    <div style="margin: 5px 0">思维导图</div>
                  </div>
                  <div class="check" @click="chapAddTools(3)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(3) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(31)">
                    <img src="../../assets/icon/secondToolList/networkPanel.png" alt />
                    <div style="margin: 5px 0">数学画板</div>
                  </div>
                  <div class="check" @click="chapAddTools(31)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(31) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
              </div>
              <div class="toolSort" v-if="chapToolsType == 2">
                <div class="tool">
                  <div class="whiteBIcon" @click="chapAddTools(5)">
                    <img src="../../assets/icon/thirdToolList/score.png" alt />
                    <div style="margin: 5px 0">量规评分</div>
                  </div>
                  <div class="check" @click="chapAddTools(5)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(5) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
                <div class="tool">
                  <div class="whiteBIcon" @click="openTools(chapCount, 4, null)">
                    <img src="../../assets/icon/thirdToolList/ask.png" alt />
                    <div style="margin: 5px 0">选择题</div>
                  </div>
                  <div class="check" @click="chapAddTools(4)">
                    <img src="../../assets/icon/checkNo.png" alt v-if="itemTools.tools.indexOf(4) == -1" />
                    <img src="../../assets/icon/checkedIs.png" alt v-else />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <input type="text" placeholder="添加工具描述" class="binfo_input"
                style="margin: 20px 0; width: 71.5% !important" v-model="itemTools.toolDetail" />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="addChaptersDataTools">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加问答" :visible.sync="dialogVisible8" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div class="a_add_title" style="
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
          ">
          <div style="margin-bottom: 20px; font-size: 20px">问题:</div>
          <el-input v-model="answerQ" placeholder="请输入您要问的问题"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible8 = false">取 消</el-button>
        <el-button type="primary" @click="addAnswer">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加问题" :visible.sync="dialogVisibleMp3" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div class="a_add_title" style="
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
          ">
          <div style="margin-bottom: 20px; font-size: 20px">问题:</div>
          <el-input v-model="answerQ" placeholder="请输入您想要回答的问题"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMp3 = false">取 消</el-button>
        <el-button type="primary" @click="addMp3Answer">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传图片" :visible.sync="choosePicVisible" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div class="fileCss" style="padding-top: 20px">
          <div>
            <button class="info_btn" @click="addImg($event)">
              选择本地文件
              <input type="file" accept="image/*" style="display: none" @change="beforeUpload1" />
            </button>
          </div>
          <div>
            <el-button @click="getAllBanner" v-if="isSysPic == false && cover.length == 0">选择系统文件</el-button>
            <div class="isSysPic" v-if="isSysPic == true && cover.length > 0">
              <img :src="cover[0].url" alt="" />
              <div class="deletePic" @click="deleteSysPic">
                <img src="../../assets/icon/delete.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="fileCss">
          <div>选择本地文件</div>
          <div>选择系统文件</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="choosePicVisible = false">取 消</el-button>
        <el-button type="primary" @click="choosePicVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择系统文件" :visible.sync="sysPicVisible" :append-to-body="true" width="700px"
      :before-close="handleClose" class="dialog_diy">
      <div class="cru_selectBox" style="margin: 0">
        <div @click="getChoosePic(1)" class="cru_select" :class="chooseType == 1 ? 'cru_selected' : ''">
          绘画
        </div>
        <div @click="getChoosePic(2)" class="cru_select" :class="chooseType == 2 ? 'cru_selected' : ''">
          科技
        </div>
        <div @click="getChoosePic(3)" class="cru_select" :class="chooseType == 3 ? 'cru_selected' : ''">
          人文
        </div>
        <div @click="getChoosePic(4)" class="cru_select" :class="chooseType == 4 ? 'cru_selected' : ''">
          艺术
        </div>
      </div>
      <div class="sysPicBox">
        <div v-for="(sys, sysIndex) in sysPic" :key="sysIndex" class="sysPic">
          <img :src="sys.poster" alt="" @click="chooseSysPic(sys.poster)" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sysPicVisible = false">取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择填空" :visible.sync="dialogVisibleSelect" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy dialog_diy3">
      <div v-if="selectJson">
        <div class="select_box1" v-if="selectSteps == 1">
          <div class="select_box1_img">
            <div class="select_box1_title">
              <span>上传题目图片</span><span>提示：请将题目以图片的方式上传</span>
            </div>
            <div class="select_box1_add_img">
              <div class="uploadFm" @click="addImg($event)" v-if="!selectJson.url">
                <input type="file" accept="image/*" style="display: none" @change="beforeUploadSelect" />
                <img src="../../assets/icon/addPoster.png" alt="" />
              </div>
              <div class="isSysPic" v-else>
                <img :src="selectJson.url" alt="" />
                <div class="deletePic" @click="deleteSelectPic">
                  <img src="../../assets/icon/delete.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="select_box1_select">
            <div class="select_box1_title">
              <span>添加选项</span><span>提示：请输入题目选项</span>
            </div>
            <div class="select_box1_select_box">
              <el-input v-for="(item2, checkIndex) in selectJson.select" :key="checkIndex"
                v-model="selectJson.select[checkIndex]" placeholder="请输入选项..."
                style="width: 150px; margin: 10px 10px 0 0"></el-input>
              <div class="select_box1_select_box_add">
                <el-button style="margin: 10px 0px 0 0" type="primary" size="small" @click="addSelectList(selectJson)">
                  添加</el-button>
                <el-button type="primary" size="small" style="margin: 10px 0 0 0" @click="deleteSelectList(selectJson)"
                  v-if="selectJson.select && selectJson.select.length > 0">删除</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectSteps == 2">
          <div class="select_box2">
            <div class="select_box2_title">设置答案</div>
            <div class="select_box2_box">
              <div class="select_box2_img">
                <img :src="selectJson.url" alt="" />
              </div>
              <div class="select_box2_answer">
                <div class="select_answer_title">根据题目选择对应答案</div>
                <div class="select_box2_answer_box" v-for="(item2, checkIndex) in selectJson.select" :key="checkIndex">
                  <span>{{ checkIndex + 1 }}、</span>
                  <el-select v-model="selectJson.answer[checkIndex]" placeholder="请选择正确答案">
                    <el-option v-for="(e, eIndex) in selectJson.select" :key="eIndex" :label="e" :value="eIndex">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="nextSelectSteps()" v-if="selectSteps == 1">下一步</el-button>
        <el-button @click="selectSteps--" v-if="selectSteps == 2">上一步</el-button>
        <el-button type="primary" @click="addSelectAnswer" v-if="selectSteps == 2">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加评价" :visible.sync="dialogVisibleRate" :append-to-body="true" width="650px"
      :before-close="handleClose" class="dialog_diy">
      <div style="background: #fff; padding: 15px; box-sizing: border-box">
        <div style="font-size: 18px; color: #a9a9a9">请输入学生评价指标:</div>
        <div class="pjCss" style="width: 100%">
          <div v-if="rateJson.length" class="elist_input" style="height: 360px; overflow: auto">
            <div v-for="(eItem, eIndex) in rateJson" :key="eIndex" class="elist_input_box">
              <span style="min-width: 100px; text-align: right">学生评价指标：</span>
              <input type="input" v-model="eItem.value" placeholder="填写评价名称" />
              <div class="remove" @click="deletRateList(eIndex)"></div>
              <div style="width: 100%; display: flex">
                <span style="min-width: 100px; text-align: right">评星等级：</span>
                <el-rate v-model="eItem.score" disabled></el-rate>
              </div>
              <div class="elist_inptu_text" style="align-items: flex-start">
                <span style="min-width: 100px; text-align: right">描述：</span>
                <textarea class="rate_textarea" :rows="3" v-model="eItem.detail" placeholder="填写评价描述"></textarea>
              </div>
            </div>
          </div>
          <div class="addToolFun" @click="addRateList()">
            <div class="addToolImg">
              <img src="../../assets/icon/add.png" alt />
            </div>
            <div>添加</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRate = false">取 消</el-button>
        <el-button type="primary" @click="addRateAnswer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "../../common/aws-sdk-2.235.1.min.js";
import $ from "jquery";
import EditorBar from "../../components/tools/wangEnduit";
import Mind from "../tools/jsmind2";
import Sunburst from "../tools/sunburst";
import SeeBoard from "../tools/seeBoard";
export default {
  components: { EditorBar, Mind, Sunburst, SeeBoard },
  data() {
    return {
      checkAll: false,
      chooseType: 1,
      checkedCities: [],
      isIndeterminate: true,
      isSysPic: false,
      steps: 1,
      nbOrder: 0,
      courseId: "",
      chapToolsType: 0,
      chapTools: [
        {
          tools: [],
          toolDetail: "",
        },
      ],
      line: "",
      sysPic: [],
      lineCount: 0,
      lineType: 0,
      chapCount: 0,
      courseName: "",
      isTeacherSee: true,
      courseText: "",
      formLabelWidth: "100px",
      choosePicVisible: false,
      sysPicVisible: false,
      uploadLoading1: false,
      noneBtnImg: false,
      updateBoolean2: false,
      unitIndex: 0,
      taskCount: 0,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      dialogVisible8: false,
      dialogVisible9: false,
      dialogVisibleClass: false,
      dialogVisibleMember: false,
      dialogVisibleMp3: false,
      dialogVisibleSelect: false,
      dialogVisibleRate: false,
      publicTool: 0,
      searchPeople: "",
      searchTN: "",
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      cid: this.$route.query.cid != undefined ? this.$route.query.cid : "",
      cover: [], //项目封面
      myWord: [],
      evaJuri: [],
      evalua: "",
      eTitle: "",
      eJson: {},
      fid: "", //一级
      sid: "", //二级
      tid: "", //二级
      typeMode: 1,
      eJSONNum: 0,
      data: {
        meta: {
          name: "example",
          author: "dd@163.com",
          version: "0.2",
        },
        format: "node_array",
        data: [{ id: "root", isroot: true, topic: "" }],
      },
      askJson: {
        askCount: 1,
        askTitle: "",
        askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
      },
      selectJson: {},
      rateJson: [],
      unitJson2: [],
      unitJson: [
        {
          dyName: "", //单元标题
          chapterInfo: [
            {
              isread: false,
              chapterid: this.guid(),
              title: "",
              courseName: "",
              taskJson: [
                {
                  task: "",
                  taskDetail: "",
                  chapterData: [],
                  toolText: "",
                  toolChoose: [
                    {
                      tool: [],
                      toolDetail: "",
                      toolType: 0,
                      askCount: 1,
                      askTitle: "",
                      askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
                    },
                  ],
                  isShowTools: false,
                  askCount: 1,
                  isFold: 0,
                  askTitle: "",
                  askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
                  checkJson: [{ checkCount: [], checkPerent: [] }],
                  homeworkList: [],
                },
              ],
              itemCount: 1,
              fileList1: [],
              video: [],
              testData: [],
              pData: [],
              templateArray: [],
            },
          ],
        },
      ],
      studentJuri: [],
      teacherJuri: [],
      checkboxList: [],
      checkboxList2: [],
      checkboxList3: [],
      number: "",
      tTitle: "",
      tdetail: "",
      templateC: {},
      AttText: {},
      AttTextType: 0,
      AttTextIndex: 0,
      cTemplate: "",
      CourseType: [],
      CourseTypeJson: {},
      courseTypeId: [],
      courseTypeSon: [],
      clearArray: [],
      loading: false,
      toolType: 0,
      inputShow: true,
      toolIndex: 0,
      cidType: 0,
      answerQ: "",
      grade: [],
      courseUserid: "",
      timer: null,
      checkId: "",
      isDelete: 1,
      addindex: 0,
      selectSteps: 1,
    };
  },
  computed: {
    offsetLetfPx: function () {
      //addnum可以直接在模板语法里面用，相当于data内的值
      return (
        $(".cru_select")[this.unitIndex] &&
        $(".cru_select")[this.unitIndex].offsetLeft
      );
    },
  },
  watch: {
    unitIndex(newValue, oldValue) {
      if (this.isDelete == 2) {
        this.isDelete = 1;
        return;
      }
      if (this.cid != "") {
        let _unitIndex = oldValue;
        if (
          JSON.stringify(this.unitJson2[_unitIndex]) ==
          JSON.stringify(this.unitJson[_unitIndex])
        ) {
          return;
        }
        let cPan = 1;
        for (
          var j = 0;
          j < this.unitJson[_unitIndex].chapterInfo[0].taskJson.length;
          j++
        ) {
          if (
            this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].toolChoose
              .length > 1
          ) {
            for (
              var z = 0;
              z <
              this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].toolChoose
                .length;
              z++
            ) {
              if (
                !this.unitJson[_unitIndex].chapterInfo[0].taskJson[j]
                  .toolChoose[z].tool.length
              ) {
                this.$message.error("请把工具添加完整");
                cPan = 2;
                break;
              }
            }
          }
          if (this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList) {
            this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList =
              this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList.filter(
                (ele) => {
                  return ele.value != "";
                }
              );
          }
        }
        if (cPan == 2) {
          this.unitIndex = oldValue;
          return;
        }
        for (var i = 0; i < this.unitJson.length; i++) {
          if (this.addindex != i) {
            delete this.unitJson[i].isUpdate;
          }
        }
        this.addindex = -1;
        let params = [
          {
            cid: this.cid,
            chapters: JSON.stringify(this.unitJson),
            uid: this.userid,
            unitIndex: _unitIndex,
          },
        ];
        this.ajax
          .post(this.$store.state.api + "updateWorkNew4", params)
          .then((res) => {
            // this.$message({
            //   message: "修改成功",
            //   type: "success",
            // });
            // this.courseId = this.cid;
          })
          .catch((err) => {
            this.$message.error("网络不佳");
            console.error(err);
          });
      }
    },
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    addHw(e) {
      var el = e.currentTarget;
      el.getElementsByTagName("input")[0].click();
    },
    change(val) {
      console.log(val);
    },
    change2(val) {
      console.log(val);
      this.$forceUpdate();
    },
    handleClose(done) {
      done();
    },

    imgChange1(file, fileList, type, itemTaskIndex) {
      if (type == 1) {
        var _tmp = this.cover;
      } else if (
        type == 2 ||
        type == 3 ||
        type == 6 ||
        type == 7 ||
        type == 8
      ) {
        var _tmp =
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .chapterData;
      } else if (type == 4) {
        var _tmp = this.unitJson[this.unitIndex].chapterInfo[0].fileList1;
      } else {
        var _tmp =
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .homeworkList;
      }
      this.noneBtnImg = _tmp.length >= 1;
    },
    goTo(path) {
      this.$router.push(path);
    },
    guid() {
      var _num,
        i,
        _guid = "";
      for (i = 0; i < 32; i++) {
        _guid += Math.floor(Math.random() * 16).toString(16); //随机0  - 16 的数字 转变为16进制的字符串
        _num = Math.floor((i - 7) / 4); //计算 (i-7)除4
        if (_num > -1 && _num < 4 && i == 7 + 4 * _num) {
          //会使guid中间加 "-"   形式为xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
          _guid += "-";
        }
      }
      return _guid;
    },
    lastSteps() {
      if (this.steps == 4) {
        this.goTo(
          "/course?userid=" +
          this.userid +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org
        );
      } else {
        if (this.cidType == 0) {
          this.steps--;
          if (this.steps == 1) {
            setTimeout(() => {
              this.checkEva(this.checkId);
            }, 0);
          }
        } else {
          if (this.steps == 3) {
            this.steps = 1;
            setTimeout(() => {
              this.checkEva(this.checkId);
            }, 0);
          }
        }
      }
    },
    navSteps(s) {
      if (this.courseName == "") {
        this.$message.error("请将信息填写完整");
        return;
      }
      if (this.cidType == 0) {
        if (this.steps == 1) {
          if (this.cid == "" || this.cid == undefined) {
            this.addWork();
          } else {
            if (this.userid != this.courseUserid) {
              // this.updateWork2();
            } else {
              this.updateWork();
            }
          }
        }
        if (s == 1) {
          this.steps = 1;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 0);
        }
        if (s == 2) {
          this.steps = 2;
        }
        if (s == 3) {
          this.cTemplate = this.templateC.content;
          this.dialogVisible2 = false;
          this.steps = 3;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 1000);
        }
      } else {
        if (this.steps == 1) {
          if (this.cid == "" || this.cid == undefined) {
            this.addWork();
          } else {
            if (this.userid != this.courseUserid) {
              // this.updateWork2();
            } else {
              this.updateWork();
            }
          }
        }
        if (s == 1) {
          this.steps = 1;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 0);
        }
        if (s == 3) {
          this.cTemplate = this.templateC.content;
          this.dialogVisible2 = false;
          this.steps = 3;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 1000);
        }
      }
      this.$refs.stepBox.scrollTop = 0;
    },
    nextSteps() {
      if (this.cidType == 1) {
        if (this.steps == 1) {
          if (this.courseName != "") {
            this.steps = 3;
            setTimeout(() => {
              this.checkEva(this.checkId);
            }, 1000);
            if (this.cid == "" || this.cid == undefined) {
              this.addWork();
            } else {
              if (this.userid != this.courseUserid) {
                // this.updateWork2();
              } else {
                this.updateWork();
              }
            }
          } else {
            this.$message.error("请将信息填写完整");
            return;
          }
        } else if (this.steps == 3) {
          if (this.cid == "" || this.cid == undefined) {
            if (this.courseName == "") {
              this.$message.error("请将信息填写完整");
              return;
            } else {
              this.addWork();
              this.steps++;
            }
          } else {
            if (this.courseName == "") {
              this.$message.error("请将信息填写完整");
              return;
            } else {
              if (this.userid != this.courseUserid) {
                this.updateWork2();
              } else {
                this.updateWork();
              }
              this.steps++;
            }
          }
        }
      } else {
        if (this.steps == 1) {
          if (this.courseName != "") {
            if (this.cid == "" || this.cid == undefined) {
              this.addWork();
            } else {
              if (this.userid != this.courseUserid) {
                // this.updateWork2();
              } else {
                this.updateWork();
              }
            }
            this.steps++;
          } else {
            this.$message.error("请将信息填写完整");
            return;
          }
        } else if (this.steps == 2) {
          if (this.templateC.id != "" || this.templateC.id != undefined) {
            this.cTemplate = this.templateC.content;
          }
          this.dialogVisible2 = false;
          this.steps++;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 1000);
        } else if (this.steps == 3) {
          if (this.cid == "" || this.cid == undefined) {
            if (this.courseName == "") {
              this.$message.error("请将信息填写完整");
              return;
            } else {
              this.addWork();
              this.steps++;
            }
          } else {
            if (this.courseName == "") {
              this.$message.error("请将信息填写完整");
              return;
            } else {
              if (this.userid != this.courseUserid) {
                this.updateWork2();
              } else {
                this.updateWork();
              }
              this.steps++;
            }
          }
        }
      }
      this.$refs.stepBox.scrollTop = 0;
    },
    unitSet(i) {
      this.unitIndex = i;
      this.$refs.rightboxR.scrollTop = 0;
    },
    time() {
      if (!this.now) {
        this.now = new Date().getTime();
        return true;
      } else {
        let time = new Date().getTime();
        if (time - this.now > 3000) {
          this.now = time;
          return true;
        } else {
          return false;
        }
      }
    },
    deleteUnit(i) {
      var _this = this;
      if (_this.time()) {
        _this
          .$confirm("确定删除此单元吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            _this.isDelete = 2;
            // _this.unitIndex = _this.unitIndex - 1;
            _this.deleteWork(_this.unitJson[i].chapterInfo[0].chapterid);
            // _this.$message.success("删除成功");
          })
          .catch(() => {
            return;
          });
      }
    },
    deleteWork(chapid) {
      let params = [
        {
          cid: this.cid,
          chapters: JSON.stringify(this.unitJson),
          uid: this.userid,
          chapid: chapid,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "deleteWork", params)
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.unitJson.splice(this.unitIndex, 1);
          this.unitIndex = this.unitIndex - 1;
        })
        .catch((err) => {
          this.$message.error("网络不佳");
          console.error(err);
        });
    },
    deleteTool(itemTaskIndex, i) {
      var _this = this;
      if (_this.time()) {
        _this
          .$confirm("确定删除此工具吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            _this.unitJson[_this.unitIndex].chapterInfo[0].taskJson[
              itemTaskIndex
            ].toolChoose.splice(i, 1);
            _this.$message.success("删除成功");
          })
          .catch(() => {
            return;
          });
      }
    },
    openT() {
      window.parent.postMessage({ tools: "25" }, "*");
    },
    deleteTask(i) {
      var _this = this;
      if (_this.time()) {
        _this
          .$confirm("确定删除此任务吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            _this.unitJson[_this.unitIndex].chapterInfo[0].taskJson.splice(
              i,
              1
            );
            _this.$message.success("删除成功");
          })
          .catch(() => {
            return;
          });
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },
    clean(i, c) {
      this.unitJson[this.unitIndex].chapterInfo[i].fileList1.splice(c, 1);
    },
    handle_remove1(file, fileList, type) {
      var _tmp = this.cover;
      for (var i = 0, len = _tmp.length; i < len; i++) {
        if (_tmp[i].uid == file.uid) {
          _tmp.splice(i, 1);
          break;
        }
        this.cover = _tmp;
      }
      this.noneBtnImg = _tmp.length >= 1;
      this.isSysPic = false;
    },
    addImg(e) {
      var el = e.currentTarget;
      el.getElementsByTagName("input")[0].click();
    },
    addChaptersTools(i) {
      this.chapTools = [
        {
          tools: [],
          toolDetail: "",
        },
      ];
      this.chapCount = i;
      this.dialogVisible4 = true;
    },
    isNoFinsh() {
      this.$message.warning("功能正在开发中");
    },
    addAttText(i) {
      this.AttText = {
        title: "",
        text: "",
      };
      this.taskCount = i;
      this.AttTextType = 0;
      this.$forceUpdate();
      this.dialogVisible6 = true;
    },
    openLine(i) {
      this.line = "";
      this.lineCount = i;
      this.lineType = 0;
      this.$forceUpdate();
      this.dialogVisible7 = true;
    },
    beforeUpload1(event, type) {
      const loading = this.openLoading();
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function (err, data) {
            loading.close();
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              _this.cover.push({
                name: file.name,
                url: data.Location,
                uid: file.uid,
              });
              _this.imgChange1(null, null, 1, null);
              _this.choosePicVisible = false;
              console.log(data.Location);
            }
          });
      }
    },
    beforeUploadSelect(event, type) {
      const loading = this.openLoading();
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function (err, data) {
            loading.close();
            if (err) {
              _this.$message.error("上传失败");
            } else {
              _this.selectJson.url = data.Location;
              console.log(data.Location);
            }
          });
      }
    },
    chooseSysPic(p) {
      this.cover.push({
        name: "系统图片.png",
        url: p,
      });
      this.imgChange1(null, null, 1, null);
      this.isSysPic = true;
      this.sysPicVisible = false;
    },
    beforeUpload(data) {
      this.$refs.upload1.uploadFiles;
      this.uploadLoading1 = true;
      var file = data.file;
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function (err, data) {
            _this.uploadLoading1 = false;
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              //上传成功处理
              _this.unitJson[_this.unitIndex].chapterInfo[0].fileList1.push({
                name: file.name,
                url: data.Location,
                uid: file.uid,
              });
              _this.imgChange();
              console.log(data.Location);
            }
          });
      }
    },
    onExceed() {
      this.$message.error("项目封面仅支持上传一张，请删除后再进行上传");
    },
    beforeUpload2(event, unitIndex, type, itemTaskIndex) {
      const loading = this.openLoading();
      var file = event.target.files[0];
      this.inputShow = false;
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      if (type == 3) {
        var b = [
          "DOC",
          "DOCX",
          "DOCM",
          "DOTM",
          "DOTX",
          "PPTX",
          "PPSX",
          "PPT",
          "PPS",
          "PPTM",
          "POTM",
          "PPAM",
          "POTX",
          "PPSM",
        ];
        if (
          b.indexOf(
            file.name
              .split(".")
            [file.name.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          if (file.size / 1024 / 1024 > 10) {
            this.$message.error("上传文件大于10兆,请重新选择文件！");
            var a = _this.$refs.upload1.uploadFiles;
            a.splice(a.length - 1, a.length);
            loading.close();
            return;
          }
        } else if (
          file.name
            .split(".")
          [file.name.split(".").length - 1].toLocaleUpperCase() != "PDF"
        ) {
          if (file.size / 1024 / 1024 > 5) {
            this.$message.error("添加成上传文件大于5兆,请重新选择文件！");
            var a = _this.$refs.upload1.uploadFiles;
            a.splice(a.length - 1, a.length);
            loading.close();
            return;
          }
        }
      }

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function (err, data) {
            loading.close();
            _this.inputShow = true;
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              if (type == 2 || type == 3) {
                _this.unitJson[unitIndex].chapterInfo[0].taskJson[
                  itemTaskIndex
                ].chapterData.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type,
                });
                _this.imgChange1(null, null, type, itemTaskIndex);
              } else if (type == 4) {
                _this.unitJson[_this.unitIndex].chapterInfo[0].taskJson[
                  itemTaskIndex
                ].fileList1.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange1(null, null, type, itemTaskIndex);
              } else if (type == 5) {
                _this.unitJson[_this.unitIndex].chapterInfo[0].taskJson[
                  itemTaskIndex
                ].homeworkList.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange1(null, null, type, itemTaskIndex);
              }
              console.log(data.Location);
            }
          });
      }
    },
    addunit() {
      this.unitJson.push({
        dyName: "", //单元标题
        isUpdate: 1,
        chapterInfo: [
          {
            isread: false,
            chapterid: this.guid(),
            title: "",
            courseName: "",
            taskJson: [
              {
                task: "",
                taskDetail: "",
                chapterData: [],
                toolText: "",
                toolChoose: [
                  {
                    tool: [],
                    toolDetail: "",
                    toolType: 0,
                    askCount: 1,
                    askTitle: "",
                    askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
                  },
                ],
                isShowTools: false,
                askCount: 1,
                isFold: 0,
                askTitle: "",
                askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
                checkJson: [{ checkCount: [], checkPerent: [] }],
                homeworkList: [],
              },
            ],
            itemCount: 1,
            fileList1: [],
            video: [],
            testData: [],
            pData: [],
            templateArray: [],
          },
        ],
      });
      this.addindex = this.unitJson.length - 1;
      setTimeout(() => {
        this.unitIndex = this.unitJson.length - 1;
        this.unitSet(this.unitIndex);
      }, 0);
    },
    addToolFun(itemTaskIndex) {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        itemTaskIndex
      ].toolChoose.push({
        tool: [],
        toolDetail: "",
        toolType: 0,
        askCount: 1,
        askTitle: "",
        askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
      });
    },
    addTaskBorder() {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson.push({
        task: "",
        taskDetail: "",
        chapterData: [],
        toolText: "",
        toolChoose: [
          {
            tool: [],
            toolDetail: "",
            toolType: 0,
            askCount: 1,
            askTitle: "",
            askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
          },
        ],
        isShowTools: false,
        askCount: 1,
        isFold: 0,
        askTitle: "",
        askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
        checkJson: [{ checkCount: [], checkPerent: [] }],
        homeworkList: [],
      });
    },
    add(e, i) {
      var el = e.currentTarget;
      el.getElementsByTagName("input")[0].click();
    },
    fold(i, e, type) {
      var a = e.path[3];
      var b = e.path[2];
      if (type == 1) {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[i].isFold = 1;
        a.className += " smallTaskBorder";
        b.className += " funBlockTop";
      } else {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[i].isFold = 0;
        a.className = "taskBorder";
        b.className = "funBlock";
      }
      console.log(e);
    },
    deleteHomeworkBox(unitIndex, index, i) {
      this.unitJson[unitIndex].chapterInfo[index].taskJson[
        this.taskCount
      ].homeworkList.splice(i, 1);
    },
    getStudent() {
      let params = {
        oid: this.oid,
        cu: "",
        cn: this.searchPeople,
      };
      this.ajax
        .get(this.$store.state.api + "selectStudentAdd", params)
        .then((res) => {
          this.studentJuri = res.data[0];
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    getTeacher() {
      let params = {
        oid: this.oid,
        cu: "",
        cn: this.searchTN,
      };
      this.ajax
        .get(this.$store.state.api + "selectTeacherAdd", params)
        .then((res) => {
          let teacherJuri = res.data[0];
          for (var i = 0; i < teacherJuri.length; i++) {
            if (teacherJuri[i].userid == this.userid) {
              teacherJuri.splice(i, 1);
              break;
            }
          }
          this.teacherJuri = teacherJuri;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    searchStudent() {
      this.getStudent();
    },
    //获取班级列表
    getClass() {
      let params = {
        oid: this.oid,
      };
      this.ajax
        .get(this.$store.state.api + "selectClassBySchool", params)
        .then((res) => {
          this.grade = res.data[0];
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    getChapterData(e, i, j, ic, type) {
      e.stopPropagation();
      this.updataC = true;
      this.icc = ic;
      if ((type == 2 || type == 3) && e.target.tagName !== "INPUT") {
        console.log("还不能下载图片喔");
      }
    },
    deleteChapterData(e, i, j, ic, taskI) {
      e.stopPropagation();
      this.unitJson[i].chapterInfo[j].taskJson[taskI].chapterData.splice(ic, 1);
    },
    updataVideoT(e, i, j, ic) {
      e.stopPropagation();
      this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic
      ].name = e.target.value;
    },
    upCd(e, i, j, ic) {
      e.stopPropagation();
      if (ic == 0) {
        return;
      }
      var a =
        this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic - 1
        ];
      this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic - 1
      ] =
        this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic
        ];
      this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[ic] =
        a;
    },
    downCd(e, i, j, ic) {
      e.stopPropagation();
      if (ic == this.unitJson[i].chapterInfo[j].chapterData.length - 1) {
        return;
      }
      var a =
        this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic + 1
        ];
      this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic + 1
      ] =
        this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[
        ic
        ];
      this.unitJson[i].chapterInfo[j].taskJson[this.taskCount].chapterData[ic] =
        a;
    },
    addWork() {
      let cPan = 1;
      for (var i = 0; i < this.unitJson.length; i++) {
        for (
          var j = 0;
          j < this.unitJson[i].chapterInfo[0].taskJson.length;
          j++
        ) {
          if (
            this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose.length > 1
          ) {
            for (
              var z = 0;
              z < this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose.length;
              z++
            ) {
              if (
                !this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose[z].tool
                  .length
              ) {
                this.$message.error("请把工具添加完整");
                cPan = 2;
                break;
              }
            }
          }
          if (this.unitJson[i].chapterInfo[0].taskJson[j].eList) {
            this.unitJson[i].chapterInfo[0].taskJson[j].eList = this.unitJson[
              i
            ].chapterInfo[0].taskJson[j].eList.filter((ele) => {
              return ele.value != "";
            });
          }
        }
      }

      if (cPan == 2) {
        this.steps--;
        return;
      }
      for (var i = 0; i < this.unitJson.length; i++) {
        delete this.unitJson[i].isUpdate;
      }
      let params = [
        {
          uid: this.userid,
          title: this.courseName,
          brief: this.courseText.replace(/%/g, "%25"),
          cover:
            this.cover.length > 0
              ? JSON.stringify(this.cover)
              : JSON.stringify([
                {
                  name: "noBanner.jpg",
                  url: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/noBanner1656409780264.jpg",
                  uid: 1656409780264,
                  status: "success",
                },
              ]),
          evaId: this.evalua,
          astudent:
            this.checkboxList2.length > 0 ? this.checkboxList2.join(",") : "",
          see: this.isTeacherSee == true ? 1 : 0,
          chapters: JSON.stringify(this.unitJson).replaceAll(/%/g, "%25"),
          template: this.cTemplate != "undefined" ? this.cTemplate : "",
          courseType: JSON.stringify(this.courseTypeId),
          ateacher:
            this.checkboxList3.length > 0 ? this.checkboxList3.join(",") : "",
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addWorkNew2", params)
        .then((res) => {
          console.log(this.steps);
          if (this.steps != 1 && this.steps != 2 && this.steps != 3) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
          }
          this.number = res.data.ordernumber;
          this.courseId = res.data.courseId;
          this.cid = res.data.courseId;
          this.courseUserid = this.userid;
          this.islogin = true;
        })
        .catch((err) => {
          this.$message.error("网络不佳");
          console.error(err);
        });
    },
    goCourse() {
      window.parent.postMessage({ cid: this.courseId, type: "1" }, "*");
    },
    updateWork2() {
      let _unitIndex = this.unitIndex;
      let cPan = 1;
      for (
        var j = 0;
        j < this.unitJson[_unitIndex].chapterInfo[0].taskJson.length;
        j++
      ) {
        if (
          this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].toolChoose
            .length > 1
        ) {
          for (
            var z = 0;
            z <
            this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].toolChoose
              .length;
            z++
          ) {
            if (
              !this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].toolChoose[
                z
              ].tool.length
            ) {
              this.$message.error("请把工具添加完整");
              cPan = 2;
              break;
            }
          }
        }
        if (this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList) {
          this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList =
            this.unitJson[_unitIndex].chapterInfo[0].taskJson[j].eList.filter(
              (ele) => {
                return ele.value != "";
              }
            );
        }
      }
      if (cPan == 2) {
        this.steps--;
        return;
      }
      let params = [
        {
          cid: this.cid,
          chapters: JSON.stringify(this.unitJson),
          uid: this.userid,
          unitIndex: _unitIndex,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "updateWorkNew4", params)
        .then((res) => {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.courseId = this.cid;
        })
        .catch((err) => {
          this.$message.error("网络不佳");
          console.error(err);
        });
    },
    updateWork() {
      let cPan = 1;
      for (var i = 0; i < this.unitJson.length; i++) {
        for (
          var j = 0;
          j < this.unitJson[i].chapterInfo[0].taskJson.length;
          j++
        ) {
          if (
            this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose.length > 1
          ) {
            for (
              var z = 0;
              z < this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose.length;
              z++
            ) {
              if (
                !this.unitJson[i].chapterInfo[0].taskJson[j].toolChoose[z].tool
                  .length
              ) {
                this.$message.error("请把工具添加完整");
                cPan = 2;
                break;
              }
            }
          }
          if (this.unitJson[i].chapterInfo[0].taskJson[j].eList) {
            this.unitJson[i].chapterInfo[0].taskJson[j].eList = this.unitJson[
              i
            ].chapterInfo[0].taskJson[j].eList.filter((ele) => {
              return ele.value != "";
            });
          }
        }
      }
      if (cPan == 2) {
        this.steps--;
        return;
      }
      for (var i = 0; i < this.unitJson.length; i++) {
        delete this.unitJson[i].isUpdate;
      }
      let params = [
        {
          cid: this.cid,
          title: this.courseName,
          brief: this.courseText.replace(/%/g, "%25"),
          cover:
            this.cover.length > 0
              ? JSON.stringify(this.cover)
              : JSON.stringify([
                {
                  name: "noBanner.jpg",
                  url: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/noBanner1656409780264.jpg",
                  uid: 1656409780264,
                  status: "success",
                },
              ]),
          evaId: this.evalua,
          astudent:
            this.checkboxList2.length > 0 ? this.checkboxList2.join(",") : "",
          see: this.isTeacherSee == true ? 1 : 0,
          chapters: JSON.stringify(this.unitJson).replaceAll(/%/g, "%25"),
          template: this.myWord != "undefined" ? this.myWord : [],
          uid: this.userid,
          courseType: JSON.stringify(this.courseTypeId),
          ateacher:
            this.checkboxList3.length > 0 ? this.checkboxList3.join(",") : "",
        },
      ];
      this.ajax
        .post(this.$store.state.api + "updateWorkNew2", params)
        .then((res) => {
          if (this.steps != 1 && this.steps != 2 && this.steps != 3) {
            if (this.cidType == 1) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "新增成功",
                type: "success",
              });
            }
          }
          this.number = this.nbOrder;
          this.courseId = this.cid;
        })
        .catch((err) => {
          this.$message.error("网络不佳");
          console.error(err);
        });
    },
    guid() {
      var _num,
        i,
        _guid = "";
      for (i = 0; i < 32; i++) {
        _guid += Math.floor(Math.random() * 16).toString(16); //随机0  - 16 的数字 转变为16进制的字符串
        _num = Math.floor((i - 7) / 4); //计算 (i-7)除4
        if (_num > -1 && _num < 4 && i == 7 + 4 * _num) {
          //会使guid中间加 "-"   形式为xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
          _guid += "-";
        }
      }
      return _guid;
    },
    insertWord() {
      this.dialogVisible1 = true;
      this.updateBoolean2 = false;
      this.tTitle = "";
      this.tdetail = "";
    },
    addWord() {
      this.unitJson[this.unitIndex].chapterInfo[0].fileList1.push({
        name: this.tTitle,
        content: this.tdetail,
        uid: this.guid(),
      });
      this.dialogVisible1 = false;
    },
    upWord() { },
    selectWord(uid, i, c) {
      this.dialogVisible1 = true;
      this.updateBoolean2 = true;
      if (
        uid == this.unitJson[this.unitIndex].chapterInfo[i].fileList1[c].uid
      ) {
        this.tTitle =
          this.unitJson[this.unitIndex].chapterInfo[i].fileList1[c].name;
        this.tdetail =
          this.unitJson[this.unitIndex].chapterInfo[i].fileList1[c].content;
      }
    },
    isAddPP() {
      if (this.checkboxList.length > 0) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.dialogVisible3 = false;
      } else {
        this.$message({
          message: "请添加项目成员",
          type: "error",
        });
      }
    },
    isAddClass() {
      this.dialogVisibleClass = false;
    },
    isAddPPTeacher() {
      this.dialogVisibleMember = false;
    },
    getTemplate() {
      this.ajax
        .get(this.$store.state.api + "getCourseTemplateT", "")
        .then((res) => {
          this.templateArray = res.data[0];
        })
        .catch((err) => { });
    },
    clearChoose() {
      this.clearArray.splice(this.templateC.id, 1);
      this.dialogVisible2 = false;
    },
    clearAttText() {
      this.AttText = {
        title: "",
        text: "",
      };
      this.dialogVisible6 = false;
    },
    clearLine() {
      this.line = "";
      this.dialogVisible7 = false;
    },
    checkTemplate(res) {
      let _this = this;
      _this
        .$confirm("确定选择此模板吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          _this.unitJson = JSON.parse(res.chapters);
          _this.steps++;
          setTimeout(() => {
            this.checkEva(this.checkId);
          }, 1000);
        })
        .catch(() => {
          return;
        });
    },
    checkTemplate1(w) {
      this.steps++;
    },
    checkTemplate2() {
      let _this = this;
      _this
        .$confirm("确定选择空模板吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          _this.unitJson = [
            {
              dyName: "", //单元标题
              chapterInfo: [
                {
                  isread: false,
                  chapterid: this.guid(),
                  title: "",
                  courseName: "",
                  taskJson: [
                    {
                      task: "",
                      taskDetail: "",
                      chapterData: [],
                      toolText: "",
                      toolChoose: [
                        {
                          tool: [],
                          toolDetail: "",
                          toolType: 0,
                          askCount: 1,
                          askTitle: "",
                          askJson: [
                            { askstitle: "", askItem: 1, checkList: [] },
                          ],
                        },
                      ],
                      isShowTools: false,
                      askCount: 1,
                      isFold: 0,
                      askTitle: "",
                      askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
                      checkJson: [{ checkCount: [], checkPerent: [] }],
                      homeworkList: [],
                    },
                  ],
                  itemCount: 1,
                  fileList1: [],
                  video: [],
                  testData: [],
                  pData: [],
                  templateArray: [],
                },
              ],
            },
          ];
          this.steps++;
        })
        .catch(() => {
          return;
        });
    },
    wordNext() {
      this.dialogVisible2 = false;
    },
    isAddOrUpdateAttText() {
      if (this.AttTextType == 0) {
        this.addAttTextMessage();
      } else {
        this.updateAttText();
      }
    },
    isAddOrUpdateLine() {
      if (this.lineType == 0) {
        this.addLine();
      } else {
        this.updateLine();
      }
    },
    addAttTextMessage() {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].chapterData.push({
        name: this.AttText.title,
        url: this.AttText.text,
        type: 6,
      });
      this.imgChange1(null, null, 6, this.taskCount);
      this.dialogVisible6 = false;
    },
    selectAttText(itemTaskIndex, i) {
      this.AttText.title =
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].chapterData[i].name;
      this.AttText.text =
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].chapterData[i].url;
      this.taskCount = itemTaskIndex;
      this.AttTextIndex = i;
      this.AttTextType = 1;
      this.dialogVisible6 = true;
    },
    updateAttText() {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].chapterData[this.AttTextIndex].name = this.AttText.title;

      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].chapterData[this.AttTextIndex].url = this.AttText.text;
      this.dialogVisible6 = false;
    },
    addLine() {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.lineCount
      ].chapterData.push({
        name: "链接",
        url: this.line,
        type: 8,
      });
      this.imgChange1(null, null, 8, this.lineCount);
      this.dialogVisible7 = false;
    },
    selectLine(itemTaskIndex, i) {
      this.line =
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].chapterData[i].url;
      this.taskCount = itemTaskIndex;
      this.lineCount = i;
      this.lineType = 1;
      this.dialogVisible7 = true;
    },
    updateLine() {
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].chapterData[this.lineCount].url = this.line;
      this.dialogVisible7 = false;
    },
    addPP() {
      this.dialogVisible3 = true;
    },
    goTo(path) {
      this.$router.push(path);
    },
    openTools(itemTaskIndex, i, toolIndex) {
      this.toolIndex = toolIndex;
      this.taskCount = itemTaskIndex;
      if (i == 4) {
        if (toolIndex == null) {
          var a =
            this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
              .chapterData;
          for (var i = 0; i < a.length; i++) {
            if (a[i].url == 4 && a[i].askJson.askTitle != "") {
              this.askJson =
                this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                  itemTaskIndex
                ].chapterData[i].askJson;
            }
          }
        } else {
          this.askJson = JSON.parse(
            JSON.stringify(
              this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                itemTaskIndex
              ].toolChoose[toolIndex]
            )
          );
        }
        this.dialogVisible5 = true;
      } else if (i == 15) {
        this.answerQ = this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].toolChoose[toolIndex].answerQ
          ? JSON.parse(
            JSON.stringify(
              this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                itemTaskIndex
              ].toolChoose[toolIndex].answerQ
            )
          )
          : "";
        this.dialogVisible8 = true;
      } else if (i == 40) {
        this.rateJson = this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].toolChoose[toolIndex].rateJson
          ? JSON.parse(
            JSON.stringify(
              this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                itemTaskIndex
              ].toolChoose[toolIndex].rateJson
            )
          )
          : [{ detail: "", score: 5, value: "" }]; //{detail:"",score:5,value:""}
        this.selectSteps = 1;
        this.dialogVisibleRate = true;
      } else if (i == 42) {
        this.answerQ = this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].toolChoose[toolIndex].answerQ
          ? JSON.parse(
            JSON.stringify(
              this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                itemTaskIndex
              ].toolChoose[toolIndex].answerQ
            )
          )
          : "";
        this.dialogVisibleMp3 = true;
      } else if (i == 41) {
        this.selectJson = this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].toolChoose[toolIndex].selectJson
          ? JSON.parse(
            JSON.stringify(
              this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
                itemTaskIndex
              ].toolChoose[toolIndex].selectJson
            )
          )
          : { url: "", select: [], answer: [] };
        this.selectSteps = 1;
        this.dialogVisibleSelect = true;
      }
    },
    chapAddTools(i) {
      if (this.chapTools[0].tools.length == 0) {
        this.chapTools[0].tools.push(i);
      } else {
        if (this.chapTools[0].tools.indexOf(i) != -1) {
          this.chapTools[0].tools.splice(this.chapTools[0].tools.indexOf(i), 1);
        } else {
          this.chapTools[0].tools.push(i);
        }
      }
      this.$forceUpdate();
    },
    addChaptersDataTools() {
      if (this.chapTools[0].tools.indexOf(4) != -1) {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          this.chapCount
        ].chapterData.push({
          name: this.chapTools[0].toolDetail,
          url: this.chapTools[0].tools,
          type: 7,
          askJson: this.askJson,
        });
      } else {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          this.chapCount
        ].chapterData.push({
          name: this.chapTools[0].toolDetail,
          url: this.chapTools[0].tools,
          type: 7,
        });
      }
      this.imgChange1(null, null, 7, this.chapCount);
      this.dialogVisible4 = false;
    },
    addTools(i, itemTaskIndex, toolIndex) {
      // if (
      //   this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
      //     .toolChoose[toolIndex].tool.length == 0
      // ) {
      //   this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
      //     itemTaskIndex
      //   ].toolChoose[toolIndex].tool.push(i);
      // } else {
      //   if (
      //     this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
      //       itemTaskIndex
      //     ].toolChoose[toolIndex].tool.indexOf(i) != -1
      //   ) {
      //     this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
      //       itemTaskIndex
      //     ].toolChoose[toolIndex].tool.splice(
      //       this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
      //         itemTaskIndex
      //       ].toolChoose[toolIndex].tool.indexOf(i),
      //       1
      //     );
      //   } else {
      //     this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
      //       itemTaskIndex
      //     ].toolChoose[toolIndex].tool.push(i);
      //   }
      //   console.log(
      //     this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
      //       .toolChoose[toolIndex].tool
      //   );
      // }
      if (i == 4) {
        if (
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].askJson.askTitle == "" ||
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].askJson[0].askstitle == "" ||
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].askJson[0].checkList < 2
        ) {
          this.openTools(itemTaskIndex, 4, toolIndex);
          // this.$message({
          //   message: "请填写完整问卷内容",
          //   type: "error",
          // });
          return;
        }
      }
      if (i == 15) {
        if (
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].answerQ ||
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].answerQ == ""
        ) {
          this.openTools(itemTaskIndex, 15, toolIndex);
          // this.$message({
          //   message: "请填写问答内容",
          //   type: "error",
          // });
          return;
        }
      }
      if (i == 40) {
        if (
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].rateJson ||
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].rateJson.length
        ) {
          this.openTools(itemTaskIndex, 40, toolIndex);
          return;
        }
      }
      if (i == 41) {
        if (
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].selectJson ||
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].selectJson.url == "" ||
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].selectJson.select.length ||
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].selectJson.answer.length
        ) {
          this.openTools(itemTaskIndex, 41, toolIndex);
          return;
        }
      }
      if (i == 42) {
        if (
          !this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].answerQ ||
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
            .toolChoose[toolIndex].answerQ == ""
        ) {
          this.openTools(itemTaskIndex, 42, toolIndex);
          return;
        }
      }
      if (
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[itemTaskIndex]
          .toolChoose[toolIndex].tool.length > 0
      ) {
        if (
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
            itemTaskIndex
          ].toolChoose[toolIndex].tool.indexOf(i) != -1
        ) {
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
            itemTaskIndex
          ].toolChoose[toolIndex].tool.splice(
            this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
              itemTaskIndex
            ].toolChoose[toolIndex].tool.indexOf(i),
            1
          );
        } else {
          // this.$message({
          //   message: "每个工具只能添加一个",
          //   type: "error",
          // });
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
            itemTaskIndex
          ].toolChoose[toolIndex].tool = [];
          this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
            itemTaskIndex
          ].toolChoose[toolIndex].tool.push(i);
        }
      } else {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          itemTaskIndex
        ].toolChoose[toolIndex].tool.push(i);
      }

      this.$forceUpdate();
    },
    addAskList() {
      this.askJson.askJson.push({
        askstitle: "",
        askItem: 1,
        checkList: [],
      });
      this.askJson.askCount++;
    },
    deleteAskList() {
      this.askJson.askJson.splice(-1);
      this.askJson.askCount--;
    },
    addcheckList(json) {
      json.checkList.length++;
      json.askItem++;
    },
    deletecheckList(json) {
      json.checkList.length--;
      json.askItem--;
    },
    addSelectList(json) {
      json.select.push("");
      json.answer.push("");
    },
    deleteSelectList(json) {
      // json.select.length--;
      // json.answer.length--;
      json.select.splice(json.select.length - 1, 1)
      json.answer.splice(json.answer.length - 1, 1)
    },
    addAsk() {
      if (this.askJson.askTitle === "") {
        this.$message.error("选择题标题不能为空！");
        return;
      }
      var aj = this.askJson.askJson;
      var b = 1;
      for (var i = 0; i < aj.length; i++) {
        if (aj[i].askstitle === "") {
          var a = 1;
          for (let index = 0; index < aj[i].askItem; index++) {
            const element = aj[i].checkList[index]
              ? aj[i].checkList[index]
              : "";
            if (element != "") {
              b++;
              this.$message.error("填写了选择题选项，选择题题目不能为空！");
              return;
            } else {
              a++;
            }
          }
          if (b == 1) {
            this.$message.error("至少填写一个问题");
            return;
          }
        } else if (aj[i].askstitle != "") {
          for (let index = 0; index < aj[i].askItem; index++) {
            const element = aj[i].checkList[index]
              ? aj[i].checkList[index]
              : "";
            var index = 0;
            for (var z = 0; z < aj[i].checkList.length; z++) {
              var checkC = aj[i].checkList[z] ? aj[i].checkList[z] : "";
              if (checkC != "") {
                index++;
              } else {
                this.$message.error("选择题选项不能为空！");
                return;
              }
            }
            b++;
            if (index < 2) {
              this.$message.error(
                "填写了选择题的题目，选择题选项至少要有两项！"
              );
              return;
            }
          }
        }
      }
      this.askJson.askJson = this.askJson.askJson.filter((el) => {
        var elc = el.checkList.filter((element) => {
          return element != "";
        });
        return el.askstitle != "" && elc.length != 0;
      });
      if (!this.dialogVisible4) {
        this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
          this.taskCount
        ].toolChoose[this.toolIndex] = this.askJson;
      }

      this.dialogVisible5 = false;
    },
    addAnswer() {
      if (this.answerQ == "") {
        this.$message.error("请输入您想要问的问题");
        return;
      }
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].toolChoose[this.toolIndex].answerQ = this.answerQ;
      this.dialogVisible8 = false;
    },
    addMp3Answer() {
      if (this.answerQ == "") {
        this.$message.error("请输入您想要回答的问题");
        return;
      }
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].toolChoose[this.toolIndex].answerQ = this.answerQ;
      this.dialogVisibleMp3 = false;
    },
    addRateAnswer() {
      var a = 1;
      for (var i = 0; i < this.rateJson.length; i++) {
        if (this.rateJson[i].value == "") {
          a = 2;
          break;
        }
      }
      if (a == 2) {
        this.$message.error("请把评价信息填写完整");
        return;
      }
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].toolChoose[this.toolIndex].rateJson = this.rateJson;
      this.dialogVisibleRate = false;
    },
    addSelectAnswer() {
      if (this.selectJson.url == "") {
        this.$message.error("请上传题目");
        return;
      }
      if (!this.selectJson.select.length) {
        this.$message.error("请添加选项");
        return;
      }
      if (!this.selectJson.answer.length) {
        this.$message.error("请设置答案");
        return;
      }
      var a = 1;
      for (var i = 0; i < this.selectJson.answer.length; i++) {
        if (!this.selectJson.answer[i] && this.selectJson.answer[i] !== 0) {
          a = 2;
        }
      }
      if (a == 2) {
        this.$message.error("请设置答案");
        return;
      }
      this.unitJson[this.unitIndex].chapterInfo[0].taskJson[
        this.taskCount
      ].toolChoose[this.toolIndex].selectJson = this.selectJson;
      this.dialogVisibleSelect = false;
    },
    nextSelectSteps() {
      if (this.selectJson.url == "") {
        this.$message.error("请上传题目");
        return;
      }
      if (!this.selectJson.select.length) {
        this.$message.error("请添加选项");
        return;
      }
      var a = 1;
      for (var i = 0; i < this.selectJson.select.length; i++) {
        if (!this.selectJson.select[i]) {
          a = 2;
        }
      }
      if (a == 2) {
        this.$message.error("添加的选项不能为空");
        return;
      }
      this.selectSteps++;
    },
    selectCourseDetail() {
      if (this.cid == "" || this.cid == undefined) {
        console.log("这是新增项目");
      } else {
        this.cidType = 1;
        let params = {
          cid: this.cid,
        };
        this.ajax
          .get(this.$store.state.api + "select_course_detail", params)
          .then((res) => {
            this.loading = true;
            this.unitJson = JSON.parse(res.data[0][0].chapters);
            for (var j in this.unitJson) {
              for (var i in this.unitJson[j].chapterInfo) {
                this.unitJson[j].chapterInfo[i].taskJson[
                  this.taskCount
                ].toolChoose = this.unitJson[j].chapterInfo[i].taskJson[
                  this.taskCount
                ].toolChoose
                    ? this.unitJson[j].chapterInfo[i].taskJson[this.taskCount]
                      .toolChoose
                    : [];
              }
            }
            this.courseName = res.data[0][0].title;
            this.courseText = res.data[0][0].brief;
            this.evalua = res.data[0][0].evaId;
            this.cover = JSON.parse(res.data[0][0].cover);
            this.noneBtnImg = this.cover.length >= 1;
            // this.checkboxList =
            //   res.data[0][0].course_student.length > 0
            //     ? JSON.parse(res.data[0][0].course_student)
            //     : [];
            this.checkboxList2 = res.data[0][0].juri
              ? res.data[0][0].juri.split(",")
              : [];
            this.checkboxList3 = res.data[0][0].course_teacher
              ? res.data[0][0].course_teacher.split(",")
              : [];
            // this.isTeacherSee =
            //   res.data[0][0].is_teacher_look == 0 ? true : false;
            this.isTeacherSee = res.data[0][0].open == 1 ? true : false;
            this.myWord = res.data[0][0].template;
            this.templateC.id = "123";
            this.courseUserid = res.data[0][0].userid;
            this.nbOrder = res.data[0][0].ordernumber;
            for (var i = 0; i < res.data[1].length; i++) {
              this.courseTypeId.push(res.data[1][i].typeid);
            }
            console.log(this.courseTypeId);
            // if (this.timer) clearInterval(this.timer);
            if (this.timer) clearTimeout(this.timer);
            this.timer = null;
            // this.timer = setInterval(() => {

            this.seleteCourseUpdate();

            // }, 5000);
            this.$forceUpdate();
            setTimeout(() => {
              this.checkEva(this.evalua);
            }, 0);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    seleteCourseUpdate() {
      let params = {
        cid: this.cid,
      };
      this.ajax
        .get(this.$store.state.api + "select_course_detail", params)
        .then((res) => {
          // console.log(this.unitJson);
          let unitJson = JSON.parse(res.data[0][0].chapters);
          this.unitJson2 = JSON.parse(res.data[0][0].chapters);
          let _unitJson2 = JSON.parse(JSON.stringify(this.unitJson));
          let _unitJson = [];
          let _chapAarry = [];
          let _unitIndex = JSON.parse(JSON.stringify(this.unitIndex));
          let _unitIndex2 = JSON.parse(JSON.stringify(this.unitIndex));
          let index = 1;
          let chapindex;
          if (_unitJson2.length > unitJson.length) {
            for (let c = 0; c < _unitJson2.length; c++) {
              _chapAarry.push(_unitJson2[c].chapterInfo[0].chapterid);
            }
            for (let j = 0; j < unitJson.length; j++) {
              let count = 0;
              for (let k = 0; k < _unitJson2.length; k++) {
                if (
                  unitJson[j].chapterInfo[0].chapterid ==
                  _unitJson2[k].chapterInfo[0].chapterid
                ) {
                  count++;
                  _chapAarry.splice(
                    _chapAarry.indexOf(_unitJson2[k].chapterInfo[0].chapterid),
                    1
                  );
                  _unitJson.push(unitJson[j]);
                  break;
                }
              }
              // if(count === 0){
              //   this.$message.error("您所修改的阶段已经被其他老师删除了");
              // }
            }
            for (let k = 0; k < _unitJson2.length; k++) {
              if (_unitJson2[k].isUpdate == 1) {
                _chapAarry.splice(
                  _chapAarry.indexOf(_unitJson2[k].chapterInfo[0].chapterid),
                  1
                );
                _unitJson.push(_unitJson2[k]);
              }
            }
            console.log(_chapAarry);
            for (let d = 0; d < _unitJson2.length; d++) {
              if (
                _chapAarry.indexOf(_unitJson2[d].chapterInfo[0].chapterid) != -1
              ) {
                if (_unitIndex == d) {
                  index = 2;
                }
                chapindex = d;
                // this.$message.error("您所修改的阶段已经被其他老师删除了");
              }
            }
          } else {
            _unitJson = JSON.parse(JSON.stringify(_unitJson2));
          }

          for (let i = 0; i < unitJson.length; i++) {
            if (
              (i < _unitJson.length - 1 || i == _unitJson.length - 1) &&
              _unitJson[i].chapterInfo[0].chapterid !=
              unitJson[i].chapterInfo[0].chapterid
            ) {
              if (i == _unitJson.length - 1) {
                // this.unitIndex++
                _unitIndex2++;
              }
              _unitJson.splice(i, 0, unitJson[i]);
            } else if (i > _unitJson.length - 1) {
              _unitJson.push(unitJson[i]);
            } else if (
              _unitJson[i].chapterInfo[0].chapterid ==
              unitJson[i].chapterInfo[0].chapterid
            ) {
              _unitJson[i] = unitJson[i];
            }
            // if (i == _unitIndex) {
            //   continue;
            // } else
          }

          if (_chapAarry.length && index != 2) {
            if (chapindex < _unitIndex) {
              this.isDelete = 2;
              // this.unitIndex--;
              _unitIndex2--;
            } else if (
              _unitJson2[_unitIndex].chapterInfo[0].chapterid !=
              _unitJson[_unitIndex].chapterInfo[0].chapterid
            ) {
              this.isDelete = 2;
              for (let n = 0; n < _unitJson.length; n++) {
                if (
                  _unitJson2[_unitIndex].chapterInfo[0].chapterid ==
                  _unitJson[n].chapterInfo[0].chapterid
                ) {
                  // this.unitIndex = n;
                  _unitIndex2 = n;
                  _unitJson[n] = _unitJson2[_unitIndex];
                  break;
                }
              }
            }
          } else if (index != 2) {
            // _unitJson[this.unitIndex] = _unitJson2[_unitIndex];
            _unitJson[_unitIndex2] = _unitJson2[_unitIndex];
          }
          if (index == 1) {
            this.unitJson = _unitJson;
            this.$forceUpdate();
            setTimeout(() => {
              if (this.unitIndex != _unitIndex2) {
                this.isDelete = 2;
                this.unitIndex = _unitIndex2;
              }
            }, 0);
            this.timer = setTimeout(() => {
              this.seleteCourseUpdate();
            }, 1000);
          } else if (index == 2) {
            let _this = this;
            _this
              .$confirm(
                "您所修改的阶段已经被其他老师删除了,需要恢复嘛?",
                "提示",
                {
                  confirmButtonText: "需要",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
              .then(() => {
                if (_this.time()) {
                  _this.restoreWork(
                    _chapAarry[0],
                    _unitJson,
                    chapindex,
                    _unitJson2,
                    _unitIndex2
                  );
                }
              })
              .catch(() => {
                _this.unitJson = _unitJson;
                _this.$forceUpdate();
                setTimeout(() => {
                  if (this.unitIndex != _unitIndex2) {
                    this.isDelete = 2;
                    this.unitIndex = _unitIndex2;
                  }
                }, 0);
                _this.timer = setTimeout(() => {
                  _this.seleteCourseUpdate();
                }, 1000);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    restoreWork(chapid, unitJson, chapindex, unitJson2, unitIndex2) {
      let params = [
        {
          cid: this.cid,
          chapters: JSON.stringify(this.unitJson),
          uid: this.userid,
          chapid: chapid,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "restoreWork", params)
        .then((res) => {
          this.$message({
            message: "恢复成功",
            type: "success",
          });
          unitJson.splice(chapindex, 0, unitJson2[chapindex]);
          this.unitJson = unitJson;
          this.$forceUpdate();
          setTimeout(() => {
            if (this.unitIndex != unitIndex2) {
              this.isDelete = 2;
              this.unitIndex = unitIndex2;
            }
          }, 0);
          this.timer = setTimeout(() => {
            this.seleteCourseUpdate();
          }, 1000);
        })
        .catch((err) => {
          this.$message.error("网络不佳");
          console.error(err);
        });
    },
    getTypeName() {
      console.log(this.courseTypeId);
      this.$forceUpdate();
    },
    selectType() {
      this.ajax
        .get(this.$store.state.api + "selectType")
        .then((res) => {
          this.CourseType = res.data;
          for (var i = 0; i < res.data[0].length; i++) {
            if (!this.cid) {
              this.courseTypeId[res.data[0][i].id] = "";
            }
            if (this.oid == "69893dca-1d47-11ed-8c78-005056b86db5") {
              if (res.data[0][i].name == "栏目") {
                this.CourseType[0][i].name = "主题";
              }
            }
            for (var j = 0; j < res.data[1].length; j++) {
              if (res.data[0][i].id == res.data[1][j].pid) {
                if (!this.CourseTypeJson[res.data[0][i].id]) {
                  this.CourseTypeJson[res.data[0][i].id] = [];
                }
                this.CourseTypeJson[res.data[0][i].id].push(res.data[1][j]);
              }
            }
          }
          this.selectTypeByOid();
          this.selectTypeByOrg();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectTypeByOid() {
      let params = {
        oid: this.oid,
      };
      this.ajax
        .get(this.$store.state.api + "selectTypeByOid", params)
        .then((res) => {
          for (var i = 0; i < res.data[0].length; i++) {
            for (var j = 0; j < res.data[1].length; j++) {
              if (res.data[0][i].id == res.data[1][j].pid) {
                if (!this.CourseTypeJson[res.data[0][i].id]) {
                  this.CourseTypeJson[res.data[0][i].id] = [];
                }
                this.CourseTypeJson[res.data[0][i].id].push(res.data[1][j]);
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectTypeByOrg() {
      let params = {
        oid: this.org,
      };
      this.ajax
        .get(this.$store.state.api + "selectTypeByOrg", params)
        .then((res) => {
          for (var i = 0; i < res.data[0].length; i++) {
            for (var j = 0; j < res.data[1].length; j++) {
              if (res.data[0][i].id == res.data[1][j].pid) {
                if (!this.CourseTypeJson[res.data[0][i].id]) {
                  this.CourseTypeJson[res.data[0][i].id] = [];
                }
                this.CourseTypeJson[res.data[0][i].id].push(res.data[1][j]);
              }
            }
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    OtherMb(type) {
      this.typeMode = type;
      setTimeout(() => {
        this.checkEva(this.checkId);
      }, 0);
    },
    checkEva(id) {
      this.selectEva();
      this.evalua = id;
      this.checkId = id;
      if (this.evalua != "") {
        for (var i = 0; i < this.evaJuri.length; i++) {
          if (this.evalua == this.evaJuri[i].id) {
            this.eTitle = this.evaJuri[i].title;
            this.eJson = JSON.parse(this.evaJuri[i].content);
          }
        }
        this.data.data = [];
        this.$forceUpdate();
        setTimeout(() => {
          this.setMindData();
        }, 500);
      }
    },
    selectEva() {
      let params = {
        oid: this.oid,
      };
      this.ajax
        .get(this.$store.state.api + "selectAllEvaluation", params)
        .then((res) => {
          this.evaJuri = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setMindData() {
      this.data.data = [];
      this.data.data.push({ id: "root", isroot: true, topic: this.eTitle });
      let _eJson = Object.keys(this.eJson);
      let _e = this.eJson;
      for (let i = 0; i < _eJson.length; i++) {
        let element = _e[_eJson[i]];
        this.data.data.push({
          id: element.id,
          parentid: "root",
          topic: element.name,
        });
        let _eJsonc = Object.keys(element.child);
        let _e2 = element.child;
        for (let j = 0; j < _eJsonc.length; j++) {
          let _ec = _e2[_eJsonc[j]];
          this.data.data.push({
            id: _ec.id,
            parentid: element.id,
            topic: _ec.name,
          });
          let _eJsonz = Object.keys(_ec.child);
          let _e3 = _ec.child;
          for (let z = 0; z < _eJsonz.length; z++) {
            let _ez = _e3[_eJsonz[z]];
            this.data.data.push({
              id: _ez.id,
              parentid: _ec.id,
              topic: _ez.name,
            });
          }
        }
      }
      this.$forceUpdate();
    },
    /*添加评价 */
    addEList(index, tIndex) {
      this.unitJson[index].chapterInfo[0].taskJson[tIndex].eList
        ? this.unitJson[index].chapterInfo[0].taskJson[tIndex].eList.push({
          value: "",
          detail: "",
          score: 5,
        })
        : (this.unitJson[index].chapterInfo[0].taskJson[tIndex].eList = [
          { value: "", detail: "", score: 5 },
        ]);
      this.$forceUpdate();
    },
    deletEList(index, tIndex, eIndex) {
      this.unitJson[index].chapterInfo[0].taskJson[tIndex].eList.splice(
        eIndex,
        1
      );
      this.$forceUpdate();
    },
    getChoosePic(t) {
      this.chooseType = t;
      this.getAllBanner();
    },
    getAllBanner() {
      this.sysPicVisible = true;
      let params = {
        t: this.chooseType,
      };
      this.ajax
        .get(this.$store.state.api + "selectAllBanner", params)
        .then((res) => {
          this.sysPic = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    deleteSysPic() {
      this.cover = [];
      this.isSysPic = false;
    },
    deleteSelectPic() {
      this.selectJson.url = "";
    },
    setEListStar() {
      this.$forceUpdate();
    },
    deletRateList(i) {
      this.rateJson.splice(i, 1);
    },
    addRateList() {
      this.rateJson.push({ detail: "", score: 5, value: "" });
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.timer = null;
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timer);
    this.timer = null;
    next();
  },
  created() {
    this.getStudent();
    this.getTeacher();
    this.getClass();
    this.getTemplate();
    this.selectType();
    this.selectEva();
    this.loading = false;
    setTimeout(() => {
      this.selectCourseDetail();
      this.selectEva();
    }, 500);
  },
};
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  .mbCss {
    flex-direction: column !important;
  }

  .pjCss {
    width: 100% !important;
  }

  .evaCss {
    width: 100% !important;
  }
}

.dialog_diy>>>.el-dialog__header {
  background: #3c3c3c !important;
  padding: 15px 20px;
}

.dialog_diy>>>.el-dialog__title {
  color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn {
  top: 19px;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.dialog_diy>>>.el-dialog__body,
.dialog_diy>>>.el-dialog__footer {
  background: #fafafa;
}

.dialog_diy3>>>.el-dialog__body,
.dialog_diy3>>>.el-dialog__footer {
  background: #eee !important;
}

.dialog_diy3>>>.el-dialog__body {
  padding: 20px 20px;
}

.left {
  border-right: 1px solid rgb(60, 94, 143);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 600px;
  width: 385px;
  height: 80%;
}

.tips {
  color: rgb(128, 128, 128);
  font-size: 12px;
  width: 270px;
  margin: 40px;
}

.pb_content {
  height: 100% !important;
  /* margin: 0 20px 0 20px; */
}

.pb_content_body {
  width: 100% !important;
  height: 100%;
}

.info_solid {
  width: 270px;
  height: 30px;
  border-left: 1px solid #bdbdbd;
  margin: 10px 0px 10px 30px;
}

.info_steps {
  width: 270px;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.info_steps span:nth-child(1) {
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.38);
  display: block;
  color: #fff;
  border-radius: 40px;
  text-align: center;
  line-height: 30px;
}

.steps_active {
  background: #3d67bc !important;
}

.info_steps span:nth-child(2) {
  margin-left: 5px;
}

.right {
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
}

.basic_box {
  margin: 0 auto;
  position: relative;
  padding: 0 20px 0 20px;
}

.basic_box_success {
  width: 100%;
  min-height: 455px;
  padding: 50px 0;
  position: relative;
  text-align: center;
  border-bottom: 1px solid #bfbfbf;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.info_title {
  font-size: 1.5em;
  margin-right: 25px;
  /* margin: 20px 30px 20px 30px; */
}

.bInfo_title {
  text-align: left;
  margin: 10px 0;
}

.small_title {
  font-size: 14px;
  line-height: 40px;
}

.chapter_beizhu {
  font-size: 12px;
  font-weight: bold;
  float: right;
  color: rgb(128, 128, 128);
  margin-top: 5px;
}

.chapter_uploadBox1 {
  text-align: left;
  background-color: rgb(242, 242, 242);
  width: 100%;
  height: 67px;
  padding: 0px 15px;
  border-radius: 8px;
  overflow: hidden;
  font-size: 16px;
  box-sizing: border-box;
  position: relative;
}

.chapter_add {
  width: 100%;
  height: 32px;
  margin-top: 15px;
  cursor: pointer;
}

.chapter_add_l {
  margin-left: 5px;
  width: 30px;
  height: 30px;
  float: left;
  border: 1px solid #aaa;
  color: #aaa;
  border-radius: 50%;
  font-size: 25px;
  text-align: center;
}

.chapter_add_r {
  font-size: 18px;
  height: 40px;
  line-height: 30px;
  text-indent: 10px;
  color: #aaa;
}

.chapter_add_r span {
  font-size: 12px;
  color: rgb(204, 204, 204);
}

.chapter_add_input {
  display: none;
}

.line {
  width: 85%;
  margin: 0 auto;
  border-top: 1px solid #e5e5e5;
  margin-top: 20px;
}

.info_btnBox {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin: 10px 0 10px 0;
}

.info_btn,
.teacherWord {
  color: #fff;
  background-color: #0f7eff;
  padding: 8px 24px;
  font-size: 0.9375rem;
  box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 3px 1px -2px rgb(0 0 0 / 12%);
  min-width: 64px;
  font-weight: 500;
  border-radius: 4px;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
}

.teacherWord {
  width: 105px !important;
  text-align: center !important;
  line-height: 36px !important;
  padding: 0 !important;
  font-size: 14px !important;
  margin: 10px 0 !important;
}

.wordTeacher {
  display: flex;
  flex-direction: column;
  width: 20%;
  text-align: center;
  font-size: 14px;
  margin: 30px 30px 0 10px;
  background: #fff;
  position: relative;
  border-radius: 5px;
  padding: 25px 0px;
}

.wordPic {
  margin: 0 auto;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.deleteWord {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 20px;
  top: -10px;
  cursor: pointer;
}

.wordPic>img,
.deleteWord>img,
.addToolImg>img {
  width: 100%;
  height: 100%;
}

.info_btn:hover {
  background-color: #4f7cd5 !important;
}

.cru_selectBox {
  display: flex;
  margin: 24px 0 10px;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: auto;
  position: relative;
  height: 47px;
}

.cru_selectBox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #eee;
}

/*定义滑块 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.cru_line {
  position: absolute;
  bottom: 0px;
  transition: all 0.5s;
  left: 0px;
  width: 125px;
  margin-left: -25px;
}

.cru_select {
  font-size: 21px;
  margin-right: 37px;
  margin-left: 5px;
  cursor: pointer;
  color: #a6a6a6;
}

.cru_selected {
  color: #0b7fc2 !important;
}

.chapter_contentbox {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.chapter_contentbox div:nth-child(1) {
  /* width: 150px; */
  margin: 0px;
  /* font-size: 2em; */
  color: black;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* font-weight: 600; */
  margin-right: 20px;
  font-size: 18px;
}

.chapter_contentbox div:nth-child(2) {
  width: 380px;
}

.chapter_contentbox div:nth-child(3),
.remove {
  background-image: url(../../assets/remove.png);
  cursor: pointer;
  opacity: 0.5;
  width: 40px;
  height: 50px;
  background-repeat: no-repeat;
  background-position: 5px 10px;
}

.binfo_input {
  font: inherit;
  color: currentColor;
  width: 100%;
  margin: 0;
  /* padding: 15px 14px; */
  padding: 8px 14px;
  display: block;
  min-width: 0;
  outline: none;
  box-sizing: content-box;
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
  font-size: 18px;
}

.binfo_input:focus-visible {
  border: 1px solid rgba(61, 103, 188);
}

.time {
  display: flex;
  margin: 35px 0 80px 0;
}

.chapter_btnbox {
  width: 160px;
  border-radius: 5px;
  border: 2px dashed gray;
  display: flex;
  padding: 8px 50px;
  align-items: center;
  justify-content: center;
  margin: 30px auto 0;
  cursor: pointer;
}

.icon_add {
  position: relative;
  width: 24px;
  padding-top: 20px;
  border-radius: 100%;
  border-width: 2px;
  border-style: solid;
  border-color: gray;
}

.icon_add i:nth-child(1) {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 60%;
  transform: translate(-50%, -50%);
  border-width: 1px;
  border-style: solid;
  border-color: inherit;
}

.icon_add i:nth-child(2) {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  transform: translate(-50%, -50%);
  border-width: 1px;
  border-style: solid;
  border-color: inherit;
}

.chapter_btn_w {
  font-size: 0.9375rem;
  font-weight: bold;
  color: gray;
  margin-left: 20px;
}

.disUoloadSty>>>.el-icon-plus {
  display: none !important;
  /* 上传按钮隐藏 */
}

.imgLeft {
  margin: 15px 0;
}

.add_info_box {
  margin: 20px 0;
}

.add_info_box button {
  margin: 0 10px 10px 0;
}

.add_chapters_box {
  text-align: left;
  background-color: rgb(232 234 237);
  width: 100%;
  padding: 0px 15px;
  border-radius: 15px;
  font-size: 16px;
  box-sizing: border-box;
  position: relative;
  padding: 0 10px 5px 10px;
  height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
}

.homework_box {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 15px 0 0 0;
  flex-direction: column;
  align-content: flex-start;
}

.course_homework {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin: 0 10px 0 0;
}

.course_homework>>>.el-input__inner {
  width: 140px;
  margin-left: 15px;
}

.chapter_upload_move {
  position: relative;
  background-color: #fff;
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  border: 1px solid #eee;
  border-radius: 5px;
  transition: width 2s;
  -moz-transition: width 2s;
  -webkit-transition: width 2s;
  -o-transition: width 2s;
}

.chapter_upload_l_i {
  background-image: url("../../assets/icon.png");
  background-position: 3px -165px;
  width: 30px;
  height: 30px;
  margin: 10px auto 0 auto;
}

.left_first {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.right_first {
  width: 100%;
  height: 100%;
  margin-top: 15px;
}

.right_title {
  height: 30px;
  padding: 15px 0 15px 20px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 1.5em;
  font-weight: bold;
  color: #0f7eff;
  margin: 0 auto;
}

.people {
  border: 1px solid rgb(229 229 229);
  height: 495px;
  border-radius: 5px;
  width: 100%;
  overflow: auto;
}

.people_top {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.people_nav,
.people_top_right {
  padding: 20px 0 0 20px;
}

.people_search {
  display: flex;
  position: relative;
}

.people_search>>>.el-input__inner {
  height: 25px;
  width: 95%;
}

.search_img {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 3px;
}

.search_img>img {
  width: 100%;
  height: 100%;
}

.people_name {
  display: flex;
  justify-content: flex-start;
  padding: 20px 0 0 25px;
  flex-direction: column;
  flex-wrap: wrap;
}

.people_name>>>.el-checkbox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.people_name>>>.el-checkbox__label {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

.right_img {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}

.right_img>img {
  width: 100%;
  height: 100%;
}

.number {
  margin-top: 20px;
  color: #4aa6ff;
  text-decoration: underline;
}

.success_button {
  display: flex;
  text-align: center;
  margin: 5% 0 auto;
  flex-direction: row;
  justify-content: center;
}

.look_course {
  margin-right: 40px;
  background: #3d67bc;
  width: 200px;
  height: 35px;
  line-height: 35px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.attend_others {
  width: 250px;
  background: #4fb13c;
  height: 35px;
  line-height: 35px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.dialog_diy2>>>.el-dialog__body {
  text-align: center;
}

.write_togother {
  position: absolute;
  right: 45px;
  display: flex;
  top: 5%;
}

.write_people {
  font-size: 14px;
  line-height: 50px;
  padding-right: 10px;
}

.end_write {
  background: #3d67bc;
  color: #fff;
  width: 100px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.chapter_upload {
  height: 50px;
  margin-top: 12px;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 50px;
}

.chapter_upload_t {
  background-color: #fff;
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
  border-radius: 40px;
  box-sizing: border-box;
  box-shadow: 0 0 3px 3px #dfdfdf;
}

.chapter_upload_o {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.chapter_upload_ic {
  height: 30px;
  float: right;
}

.chapter_upload_ic_l {
  width: 50px;
  height: 50px;
  float: left;
}

.chapter_upload_ic_l div {
  width: 30px;
  height: 35px;
  background: url("../../assets/icon/icon.png");
}

.chapter_upload_ic_r {
  width: 50px;
  height: 50px;
  float: left;
  margin-left: 0px;
  display: flex;
  align-items: center;
}

.chapter_upload_ic_r div {
  width: 25px;
  height: 25px;
  background-image: url("../../assets/delete.png");
  background-size: 100% 100%;
}

.chapter_upload_n {
  display: flex;
  text-indent: 10px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 55%;
  margin-left: 10px;
  cursor: pointer;
  margin-top: 2px;
}

.chapter_upload_l_i1 {
  background-image: url("../../assets/icon/video.png");
  width: 28px;
  height: 28px;
  background-size: 100% 100%;
}

.chapter_upload_l_i5 {
  background-image: url("../../assets/icon/word.png");
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
}

.chapter_upload_l_i8 {
  background-image: url("../../assets/icon/line.png");
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
}

.chapter_upload_ud {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  justify-content: center;
}

.chapter_upload_up {
  background-image: url("../../assets/icon/up.png");
  width: 17px;
  height: 15px;
  background-size: 100% 100%;
  cursor: pointer;
}

.chapter_upload_down {
  background-image: url("../../assets/icon/down.png");
  width: 17px;
  height: 15px;
  margin: 2px auto 0 auto;
  background-size: 100% 100%;
  cursor: pointer;
}

.addWordStyle {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: wrap;
}

/* table 样式 */
.cont>>>table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.cont>>>table td,
.cont>>>table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

.cont>>>table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
.cont>>>blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
.cont>>>code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

.cont>>>pre code {
  display: block;
}

/* ul ol 样式 */
.cont>>>ul,
ol {
  margin: 10px 0 10px 20px;
}

.wordbox {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  width: 100%;
}

.checkword {
  width: 22px;
  height: 22px;
  margin: 10px auto 0;
  cursor: pointer;
}

.checkword img {
  width: 100%;
}

.stepBg {
  margin: 0 25px 0 0;
  /* width: 17%; */
  min-width: 300px;
  width: 300px;
  /* border-radius: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  background: #fff;
  min-height: 700px;
  height: 100%;
  /* top: 18%; */
}

.stepBg>div {
  height: 80px;
  width: 85%;
  cursor: pointer;
  margin: 10px 0;
  border-radius: 10px;
}

.first,
.second,
.third,
.four {
  background: #4a83d0;
  height: 90px;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.first>div:nth-child(1),
.second>div:nth-child(1),
.third>div:nth-child(1),
.four>div:nth-child(1) {
  margin: 5px 10px 0 0;
  width: 2rem;
}

.firstNo,
.secondNo,
.thirdNo,
.fourNo {
  background: #e7e7e7;
  color: #adadad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.firstNo>div:nth-child(1),
.secondNo>div:nth-child(1),
.thirdNo>div:nth-child(1),
.fourNo>div:nth-child(1) {
  margin: 5px 10px 0 0;
  width: 2rem;
}

.uploadWidth>>>.el-upload {
  width: 60px;
  height: 60px;
  position: relative;
}

.addPeople {
  background: #fa6060;
  width: 150px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
}

.kcImg {
  width: 60px;
  margin-left: 10px;
}

.zyImg {
  width: 55px;
  margin: 0 10px;
}

.deleteZy {
  width: 20px;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.kcImg>img,
.zyImg>img,
.deleteZy>img {
  width: 100%;
  height: 100%;
}

.zyBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #67d37d;
  color: #fff;
  width: 210px;
  margin: 20px 20px 0 0;
  border-radius: 10px;
  height: 70px;
  position: relative;
}

.upCss {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.upCss>>>.el-icon-plus {
  position: none !important;
  width: 200px;
  height: 100px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ccc;
  min-width: 78px;
  min-height: 100px;
  z-index: 999;
}

.upCss>>>.el-upload-list__item-name {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.addStageImg {
  min-width: 25px;
  min-height: 25px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.addHW {
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.addStageImg>img,
.addHW>img {
  width: 100%;
  height: 100%;
}

.addNewPP>>>.el-dialog__body {
  padding: 5px 20px;
}

.isHeight {
  height: 680px;
}

.toolChoose {
  display: flex;
  /* width: 100%; */
  flex-direction: row;
  flex-wrap: wrap;
}

.tool {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: fit-content;
  margin: 10px 0 10px 0;
  align-items: center;
}

.tool+.tool {
  margin-right: 45px;
}

.whiteBIcon {
  width: 80px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}

.whiteBIcon>img,
.check>img,
.toolIcon>img,
.arrow>img {
  width: 100%;
  height: 100%;
}

.whiteBIcon>img {
  box-shadow: 0px 4px 8px 0px rgb(44 133 255 / 14%);
  border-radius: 15px;
}

.check {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 10px 0;
}

.customWidth>>>.el-dialog {
  min-width: 500px !important;
}

.a_addBox {
  margin: 10px 0;
  background: #fff;
  padding: 15px;
  max-height: 400px;
  overflow: auto;
}

.a_add_box {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.a_add_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 18px;
}

.a_add_head .a_add_head_input {
  width: 300px;
}

.a_add_head .a_add_head_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.a_add_body {
  display: flex;
  align-items: center;
}

.a_add_input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.width100 {
  width: 100%;
}

.a_add_input .a_add_persent {
  width: 100%;
}

.a_add_persent_div {
  width: 100%;
  display: flex;
  align-items: center;
}

.a_add_persent_div span {
  margin: 5px 0;
}

.a_add_persent_div span:nth-child(1) {
  width: 30%;
}

.a_add_persent_div span:nth-child(2) {
  width: 7%;
}

.a_add_persent_div span:nth-child(3) {
  width: 40%;
}

.a_add_body_div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.all_choose {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}

.all_choose>span {
  width: 100px;
  display: block;
  letter-spacing: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.all_choose>>>.el-checkbox-group {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3px;
}

.all_choose>.el-checkbox-group>>>.el-checkbox {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.all_choose>.el-checkbox-group>.el-checkbox>>>.el-checkbox__label {
  min-width: 80px;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.all_choose>.el-checkbox-group>.el-checkbox>>>.el-checkbox__label:hover {
  width: auto;
}

.choose>div:nth-child(3)>span {
  letter-spacing: 0 !important;
}

.choose {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-evenly;
  align-items: flex-start;
}

.both {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  margin: 30px 0;
}

.notice>>>.el-dialog {
  width: 500px !important;
  text-align: center;
}

.notice>>>.el-button {
  margin-top: 20px;
}

.whiteBg {
  background: #fff;
  border-radius: 10px;
}

.chooseWho {
  display: flex;
  width: 380px;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding-bottom: 10px;
}

.chooseWho>div {
  cursor: pointer;
  padding-bottom: 10px;
  font-weight: bold;
}

.isChooseActive {
  color: #3e88f4;
  border-bottom: 2px solid #2f80f3;
}

.toolSort {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.toolSort>div {
  margin-right: 45px;
}

.tools {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.leftTools,
.rightTools {
  width: 50%;
}

.rightTools {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.firstToolList {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}

.iconList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0 5px 0;
  width: 240px;
  min-width: 240px;
}

.iconTool {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  margin: 15px 10px;
}

.toolIcon {
  width: 50px;
}

.taskBorder {
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin-top: 20px;
  min-height: 1160px;
  position: relative;
  background: #fbfbfb;
}

.smallTaskBorder {
  height: 170px;
  min-height: 170px !important;
  overflow: hidden;
}

.taskBorder>div {
  padding: 30px 0 10px 30px;
}

.addTaskBorder {
  border: 2px solid #e1e1e1;
  border-radius: 10px;
  margin-top: 25px;
  cursor: pointer;
}

.addTaskBorder>div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.addTaskBorder>div>img {
  width: 100px;
}

.addTaskBorder>div>span {
  font-size: 23px;
  color: #dbdbdb;
}

.funBlock {
  display: flex;
  padding: 15px 0;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 15px;
  bottom: 35px;
}

.fold {
  display: flex;
  margin: 0 10px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.arrow {
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.addToolFun {
  display: flex;
  width: 150px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px dashed;
  border-radius: 5px;
  height: 50px;
  margin: 35px auto 0;
  cursor: pointer;
}

.addToolImg {
  width: 30px;
  height: 30px;
  margin-right: 20px;
}

.addToolsDia>>>.el-dialog__body {
  padding: 20px;
}

.addToolsDia>>>.el-dialog__body>.toolChoose {
  padding: 0;
}

.addToolsDia>>>.el-dialog__body>.toolChoose>.leftTools {
  padding: 0;
  border-bottom: none;
  margin-bottom: 0;
}

.addToolsDia>>>.el-dialog__body>.toolChoose>.leftTools>.chooseWho {
  width: 100%;
}

.lineCss>>>.el-form-item__label {
  width: auto !important;
}

.lineCss>>>.el-form-item__content {
  margin-left: 50px !important;
}

.newSteps {
  display: flex;
  width: 100% !important;
  height: 80px;
  cursor: pointer;
  margin: 10px 0;
  border-radius: 10px;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
}

/* 评价样式 */
.elist_css {
  padding-bottom: 60px !important;
}

.elist_title {
  margin-bottom: 10px;
}

.elist_input {}

.elist_input_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.elist_input_box+.elist_input_box {
  margin-top: 30px;
}

.elist_input .elist_input_box input {
  font: inherit;
  color: currentColor;
  /* width: 200px; */
  max-width: 200px;
  padding: 8px 14px;
  display: block;
  min-width: 0;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 20px 0 0;
}

.elist_input .elist_input_box span {
  height: 36px;
  line-height: 36px;
  color: rgb(82, 82, 82);
  min-width: 80px;
}

.elist_input .elist_input_box .remove {
  height: 20px;
  width: 20px;
  background-size: 100% 100%;
  background-position: unset;
  margin-left: 5px;
}

.elist_input_box>>>.el-rate {
  display: flex;
  height: 36px;
  align-items: center;
}

.elist_input_box .elist_inptu_text {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.elist_input_box .elist_inptu_text input {
  /* width: 500px; */
  width: 100%;
  max-width: unset;
}

.elist_input_box>>>.el-rate__icon {
  font-size: 24px;
}

.elist_btn {
  margin-top: 10px;
}

.lineTitle {
  margin-top: 15px;
  width: 110px;
}

.courseTop {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* width: 100%; */
  width: calc(100% - 20px);
  /* background: rgb(255, 255, 255); */
  /* border-radius: 10px; */
  padding: 20px 0;
}

.stepsNav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.stepsWord {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  margin-left: auto;
  background: rgb(15, 126, 255);
  border-radius: 5px;
  padding: 3px 25px;
  box-sizing: border-box;
}

.rightBox {
  width: calc(100% - 20px);
  background: rgb(255, 255, 255);
  border-radius: 10px;
  overflow: auto;
  height: calc(100% - 130px);
}

.e_add_top {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  border-radius: 3px;
  background: #fff;
}

.e_add_title2 {
  display: flex;
  align-items: center;
}

.e_add_title2 span {
  width: 40px;
}

.e_add_title {
  display: flex;
  align-items: center;
  color: #b8b8b8;
  font-size: 18px;
  position: relative;
  height: 40px;
}

.e_add_title span {
  margin-right: 10px;
}

.e_add_title .el_input {
  width: 300px;
}

.e_add_title>>>.el-input__inner {
  width: 400px;
}

.e_add_btn {}

.e_add_content {
  display: flex;
  width: 100%;
}

.e_add_list {
  background: #fff;
  height: 500px;
  width: 210px;
  position: relative;
  margin: 15px 5px 0 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.e_add_list_title {
  font-size: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 40px;
  text-align: center;
  border-bottom: 1px solid #eaeaea;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 57px;
  background: #f6f6f6;
}

.e_add_list_title span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.e_add_list_title img {
  position: absolute;
  right: 15px;
  width: 25px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.e_add_list_body {
  height: calc(100% - 187px);
  overflow: auto;
}

.e_add_list_child {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  padding: 15px 40px;
  text-align: center;
}

.e_add_list_child span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.e_add_list_child img {
  position: absolute;
  right: 10px;
  width: 21px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.e_add_list_child+.e_add_list_child {
  border-top: 1px solid #eaeaea;
}

.e_add_list_child .active {
  color: #409eff;
}

.e_add_list_btn {
  position: absolute;
  bottom: 0;
  height: 50px;
  background: rgb(120, 120, 254);
  width: 100%;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}

.e_add_list_detail {
  position: absolute;
  bottom: 0;
  height: 130px;
  background: rgb(120, 120, 254);
  width: 100%;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.e_add_list_detail textarea {
  height: 90%;
  width: 95%;
  border: none;
  resize: none;
  outline: none;
  padding: 5px;
  box-sizing: border-box;
}

.e_add_list_pbox {
  width: 100%;
}

.e_add_list_pbox_title {
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  flex-direction: row;
  flex-wrap: wrap;
}

.type_title {
  font-size: 18px;
  font-weight: 700;
}

.type_content {
  font-size: 16px;
  margin-left: 30px;
}

.type_content span+span {
  margin-left: 20px;
}

.type_content span {
  cursor: pointer;
  padding-bottom: 5px;
  box-sizing: border-box;
}

.type_content .active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.e_add_list_pbox_content {
  height: calc(100% - 50px);
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
}

.mbCss {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
  justify-content: flex-start;
}

.pjCss {
  /* width: 42%; */
  width: calc(100% - 55%);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin-top: 1.5%;
}

.e_box {
  display: flex;
  flex-wrap: wrap;
  max-height: 500px;
  align-items: flex-start;
  overflow: auto;
}

.e_card {
  border: 1px solid #ccc;
  background: #fff;
  margin-right: 20px;
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.e_card_picture {
  margin: 10px 0;
}

.e_card_picture>img {
  width: 50px;
}

.e_card_name {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e_card_time {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 15px;
  color: #c3c3c3;
  margin-bottom: 10px;
}

.e_card_btn {
  height: 40px;
  display: flex;
  align-items: center;
  width: 100%;
  background: rgb(244, 244, 244);
}

.e_card_btn:hover {
  background: rgb(221 221 221);
}

.e_card_btn span {
  flex: 1 1 auto;
  text-align: center;
  cursor: pointer;
}

.addEva {
  border: 1px solid #ccc;
  background: #fff;
  margin-right: 20px;
  width: 270px;
  height: 149px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  justify-content: center;
}

.addEva>img {
  width: 50px;
  object-fit: cover;
}

.uploadFm {
  border: 1px dashed #ccc;
  width: 202px;
  height: 102px;
  position: relative;
  cursor: pointer;
}

.uploadFm>img {
  position: absolute;
  top: 25px;
  left: 35%;
  width: 50px;
}

.fileCss {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  padding-top: 15px;
}

.sysPicBox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  height: 435px;
  overflow: auto;
}

.sysPic {
  width: 200px;
  height: 115px;
  margin: 0 20px 20px 0;
  cursor: pointer;
}

.sysPic>img,
.isSysPic>img,
.deletePic>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.isSysPic {
  width: 200px;
  height: 115px;
  position: relative;
}

.deletePic {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.select_box1 {}

.select_box1_img {
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.select_box1_title {
  padding: 0 0 15px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
}

.select_box1_title span:nth-child(1) {
  font-size: 16px;
  margin-right: 20px;
  color: #000;
}

.select_box1_title span:nth-child(2) {
  font-size: 14px;
  color: rgb(112, 112, 112);
}

.select_box1_add_img {}

.select_box1_select {
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  box-sizing: border-box;
}

.select_box2 {}

.select_box2_title {
  background: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.select_box2_box {
  display: flex;
  height: 500px;
}

.select_box2_img {
  width: calc(100% - 310px);
  height: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 5px;
}

.select_box2_img img {
  width: 100%;
}

.select_box2_answer {
  background: #fff;
  margin-left: 10px;
  border-radius: 5px;
  width: 300px;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  box-sizing: border-box;
}

.select_box2_answer_box {
  margin: 0 0 10px 0;
  width: 85%;
}

.rate_textarea {
  font: inherit;
  color: currentColor;
  width: 100%;
  padding: 8px 14px;
  display: block;
  min-width: 0;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 20px 0 0;
  resize: none;
}

.select_answer_title {
  text-align: left;
  width: 85%;
  margin-bottom: 10px;
  font-size: 18px;
  color: #8e8e8e;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/addCourse.vue